// Document ready
$(() => {
    window.riseBase.init();
    window.announcementSlider.init();
    window.productNotifyPopup.init();
    window.riseAccordian.init();
    window.riseCartFixed.init();
    window.accountAddressEvents.init();
    window.headerSearch.init();
    //window.miniCart.init();
    window.accountCreate.init();
    window.featuredPromationsSlider.init();
    window.stickyMobileCheckout.init();
    window.countryDropdownFlag.init();
    window.riseToaster.init();
    window.riseCountrySwitcher.init();
    window.subscribeFromPassword.init();
    window.PasswordNotifyPopup.init();
    window.riseCustomSelect.init();
    window.vipNotifyPopup.init();
    window.mobileAddToCartBottomSheet.init();
    //window.liveRefreshCart.init();
    window.bodyScrollLock.init();
    window.productSaleCountDown.init();
    window.passwordCountdown.init();
    window.slideShowCountDown.init();
    window.topBarCountdown.init();
    window.riseGenderSwatch.init();
    
    // Return the pathname of the current URL
    const { pathname } = location;
    if (pathname.startsWith('/pages/store-locator')) {
        window.storeLocator.init();
    }
});
/*============================================================================
  Rise Basic
==============================================================================*/
window.riseBase = {
    init: function() {
        var _this = this;
        $(document).ready(function() { 
            
            /* Show membership popup if valid date */
            if (_this.getUrlParameter('date') != false) { 
                var offerDate = new Date(_this.getUrlParameter('date').replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
                var offerDate = offerDate.setDate(offerDate.getDate() + 14);
                if (new Date() > new Date(offerDate)) {
                    $('.shopify-section--rise-membership-form .js-rise-popup-form').remove();
                    $('.shopify-section--rise-membership-form .riseform_section .container').html('<h3 class="margin-auto">Offer Expired</h3>');
                }
            }

            /* Open Rise Chat Popup (Reamaze) */
            $(document).on('click', '.icon-info, .open-chat', function(e) {
                e.preventDefault();
                $('#reamaze-widget').trigger('click');
            });
            /* Size Chart Measurement Toggle (Inch/CM)  */
            $(document).on('click', '#measurement-unit', function() { 
                if ($(this).is(':checked')) {
                    $('.size-chart-table table').removeClass('inch').addClass('cm');
                } else {
                    $('.size-chart-table table').removeClass('cm').addClass('inch');
                }
            });
            /* Remove/Hide Size Chart Image if not exists in assets */
            function imageExists(image_url){
                var http = new XMLHttpRequest();
                http.open('HEAD', image_url, false);
                http.send();
                return http.status != 404;
            }
            if ($('.size-chart-image img').length > 0 && imageExists($('.size-chart-image img').attr('src')) == false) {
                $('.size-chart-row').addClass('no-image');
            }
            /* Close fancybox when press esc key on keyboard */
            $(document).keyup(function(e) {
                // ESCAPE key pressed
                if (e.keyCode == 27) {
                    $('[data-fancybox-close]').trigger('click');
                }
            });
            /* Mobile Dropdown */
            $(document).on('click', '.mobile-dropdown', function() {
                $(this).toggleClass('open');
            });
            $(document).on('click', function(e) {
                if ($(e.target).closest('.mobile-dropdown').length === 0) {
                    $('.mobile-dropdown').removeClass('open');
                }
            });
            if ($('.notify_mobile').length > 0) {
                $('.notify_mobile').usPhoneFormat();
            }
            if ($('#header').length > 0) {
                var stickyTop = $('#header .top-bar').offset().top;
                $(window).scroll(function() {
                    var windowTop = $(window).scrollTop();
                    if (stickyTop < windowTop && $(".mobile_nav-fixed--true").height() + $(".mobile_nav-fixed--true").offset().top - $("#header .top-bar").height() > windowTop) {
                        $('#header.mobile_nav-fixed--true').addClass('mobile-stikcy');
                    } else {
                        $('#header.mobile_nav-fixed--true').removeClass('mobile-stikcy');
                    }
                });
            }
            /* Bottom Add to Cart with Reamaze */
            document.documentElement.style.setProperty('--reamazeBottom', $('.rise-add-to-cart-fixed').height() + 6 + 'px');
          	document.documentElement.style.setProperty('--RiseBottomAddToCart', '-'+$('.rise-add-to-cart-fixed').height() + 'px');
            $(window).resize(function() {
              if ($(window).width() >= 798) {
                document.documentElement.style.setProperty('--reamazeBottom', $('.rise-add-to-cart-fixed').height() + 6 + 'px');
                document.documentElement.style.setProperty('--RiseBottomAddToCart', '-'+$('.rise-add-to-cart-fixed').height() + 'px');
              } else {
                document.documentElement.style.setProperty('--reamazeBottom', '20px');
              }
            });

            /* scrollbar for mini cart */
            _this.miniCartFaded(true);
            $(window).resize(function() {
                _this.miniCartFaded();
            });

            /* close overlay on mobile search */
            $(document).on('click', '.mobile-search', function(event) {
                if (event.target.classList.contains('mobile-search')) {
                    $('.close-search').trigger('click');
                }
            });

            $(document).on('click', '.cart-container', function(event) {
                var classes = event.target.classList;
                if (classes.contains('cart-container') && classes.contains('active_link')) {
                    classes.remove('active_link');
                }
            });
            
            if ($('.js-selectpicker').length > 0) {
                $('.js-selectpicker').select2().on('select2:open', function(e) {
                    $('.select2-search__field').attr('placeholder', 'Search...');
                });
                $('.select2-selection__arrow').html('<svg viewBox="0 0 24 25" fill="none"> <path d="M2 7.80811L12 17.8081L22 7.80811" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
            }
            if ($('.js-selectpicker-without-search').length > 0) {
                $('.js-selectpicker-without-search').select2({
                    minimumResultsForSearch: Infinity
                });
                $('.select2-selection__arrow').html('<svg viewBox="0 0 24 25" fill="none"> <path d="M2 7.80811L12 17.8081L22 7.80811" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
            }

            $(document).on('click', '[data-disclosure-country] button.disclosure__button', function(event) {
                event.preventDefault();
                var $this = $(this);
                if ($this.val() == '') return;
                if (Shopify.domain == 'www.risestore.com' && $this.val() == 'CA') {
                    window.location.href = 'https://www.risestore.ca';
                } else if (Shopify.domain == 'www.risestore.ca' && $this.val() == 'US') {
                    window.location.href = 'https://www.risestore.com';
                }
                var countrySelector = $this.closest('.selectors-form__country');
                countrySelector.find('.country-code').html($this.val());
                countrySelector.find('#CountrySelector').val($this.val());
                countrySelector.find('li.disclosure-list__item').removeClass('disclosure-list__item--current');
                $this.parent('li').addClass('disclosure-list__item--current');
                $this.closest('form').submit();
            });

            const countryPopup = $('#country-popup');
            var selectedShopCurrency = localStorage.getItem('currency');
            if (selectedShopCurrency) {
                var country_selector = $('[data-disclosure-country]');
                var country_iso_code = country_selector.prev('[data-disclosure-input]').val();
                country_selector.find('.country-code').html(country_iso_code + ' (' + selectedShopCurrency + ')');
                countryPopup.find('.currency-dropdown .selected > span:first-child').html(selectedShopCurrency);
                countryPopup.find('input[name="currency_code"]').val(selectedShopCurrency);
            }
            $(document).on('click', '#country-popup button[type="submit"]', function(event) {
                event.preventDefault();
                var $this = $(this),
                    $form = $this.closest('form'),
                    country_code = $form.find('input[name="country_code"]').val(),
                    currency_code = $form.find('input[name="currency_code"]').val();
                if (country_code == '') return;
                if (Shopify.domain == 'www.risestore.com' && country_code == 'CA') {
                    window.location.href = 'https://www.risestore.ca';
                } else if (Shopify.domain == 'www.risestore.ca' && country_code == 'US') {
                    window.location.href = 'https://www.risestore.com?geolizr=off';
                } else {
                    if (Shopify.domain == 'www.risestore.ca' && country_code != 'CA') {
                        window.location.href = 'https://www.risestore.com?geolizr=off';
                    } else {
                        localStorage.setItem('currency', currency_code);
                        $form.submit();
                    }
                }
            });

            $(document).on('keyup', '[data-disclosure-country] input[name="search"]', function() {
                var wrap = $(this).closest('.disclosure__list-wrap'),
                    searchString = $(this).val();
                    wrap.find('li').each(function(index, value) {
                        currentName = $(value).text()
                        if (currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
                            $(value).show();
                        } else {
                            $(value).hide();
                        }
                    });
            });

            $(document).on('keyup', '.form-elements input[name="list_search"]', function() {
                var wrap = $(this).closest('.options'),
                    searchString = $(this).val();
                    wrap.find('li').each(function(index, value) {
                        currentName = $(value).text()
                        if (currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
                            $(value).show();
                        } else {
                            $(value).hide();
                        }
                    });
            });

            /*if ($('body').hasClass('customers-account')) {
                var localizationForm = $('#localization_form');
                var countryCode = localizationForm.find('input[name="country_code"]');
                var customer = JSON.parse($('#customer-data').html());
                if (customer && customer.id != null) {
                    var selectedCountry = countryCode.val();
                    if (selectedCountry != customer.country) {
                        countryCode.val(customer.country);
                        localizationForm.find('input[name="return_to"]').val('');
                        $.ajax({
                            type: 'PUT',
                            url: localizationForm.attr('action'),
                            data: localizationForm.serialize(),
                            success(data) {
                                var currency = localizationForm.find('input[name="currency_code"]').val();
                                console.log(currency, countryCode.val());
                                localizationForm.find('[data-disclosure-country] .country-code').html(countryCode.val() + ' (' + currency + ')');
                            }
                        });
                    }
                }
            }*/
        });
    },
    adjustCartItemScroll: function() {
        var cartWrapper = $('.tos_warning.cart_content'),
            RiseCartItemsWrapperDesk = 0,
            RiseCartItemsWrapperMob = 0;
        cartWrapper.each(function() {
            var $obj = $(this),
                cartSummaryHeight = $obj.find('.cart-summary').outerHeight();
            if ($obj.closest('.main-nav').length > 0) { // Desktop
                RiseCartItemsWrapperDesk = cartSummaryHeight;
                $obj.children().each(function() {
                    if (!$(this).is('form')) {
                        RiseCartItemsWrapperDesk += $(this).outerHeight();
                    }
                });
                document.documentElement.style.setProperty('--RiseCartItemsWrapperDesk', ($obj.outerHeight() - RiseCartItemsWrapperDesk) + 'px');
            } else { // Mobile
                RiseCartItemsWrapperMob = cartSummaryHeight;
                $obj.children().each(function() {
                    if (!$(this).is('form')) {
                        RiseCartItemsWrapperMob += $(this).outerHeight();
                    }
                });
                document.documentElement.style.setProperty('--RiseCartItemsWrapperMob', ($obj.outerHeight() - RiseCartItemsWrapperMob) + 'px');
            }
        });
    },
    miniCartFaded: function(addClass = false) {
        this.adjustCartItemScroll();
        if ($('.cart_items_wrapper.scrollbar-inner').length) {
            if (addClass == true) {
                $('.cart_items_wrapper.scrollbar-inner').parents('.cart-container').addClass('active_link');
                this.adjustCartItemScroll();
            }
            $('.cart_items_wrapper.scrollbar-inner').scrollbar({
                "onScroll": function(y, x) {
                    const $cartBottomFade = $(this.container).parents('form').find('.cart-summary'); 
                    if (y.scroll >= (y.maxScroll - 10)) { 
                        $cartBottomFade.removeClass('cart-bottom-fade');
                    } else {
                        if (y.maxScroll > 1 && !$cartBottomFade.hasClass('cart-bottom-fade')) {
                            $cartBottomFade.addClass('cart-bottom-fade');
                        }
                    }
                }
            });
            if (addClass == true) {
                $('.cart_items_wrapper.scrollbar-inner').parents('.cart-container').removeClass('active_link');
            }
        }
    },
    getUrlParameter: function(sParam) {
        var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    }
}
/*============================================================================
  Announcement Slider
==============================================================================*/
window.announcementSlider = {
    init: function() {
        var slideIndex = 1,
        slider = document.getElementsByClassName("announcement-slider");
        if (slider.length <= 0) return false;
        showSlide(slideIndex);
        autoSlide();

        function showSlide(n) {
            if (n > slider.length) { slideIndex = 1 } 
            if (n < 1) { slideIndex = slider.length }
            for (i = 0; i < slider.length; i++) {
                slider[i].style.display = "none"; 
            }
            slider[slideIndex-1].style.display = "block"; 
        }
        function changeSlide(n) {
            showSlide(slideIndex += n);
        }
        function autoSlide() {
            setInterval(function(){
                var wow = "1";
                if (wow == "1") {
                    changeSlide(-1); 
                    wow = "-1";
                    return;
                }
                if (wow == "-1") {
                    changeSlide(1); 
                    wow = "1";
                    return;
                }
            }, 9000);
        }
        $(document).on('click', '.announcement-navigation', function() {
            if ($(this).hasClass('prev')) {
                changeSlide(-1);
            } else {
                changeSlide(1);
            }
        });
    }
}

/*============================================================================
  Product Notify Popup
==============================================================================*/
window.productNotifyPopup = {
    init: function() {
        var _this = this;
        
        $(document).on('click', '.product-notify-ui-inline .notify-popup', function(e) {
            e.preventDefault();
            $selectedVariant = $(this).parents('form').find('.swatch_options input[type="radio"]:checked').next('.swatch-element');
            if ($selectedVariant.hasClass('soldout')) {
                $selectedVariant.trigger('click');
            } else {
                $swatchElements = $(this).parents('form').find('.swatch_options .swatch .swatch-element');
                $swatchElements.each(function() {
                    if ($(this).hasClass('soldout')) {
                        $(this).trigger('click');
                        return false;
                    }
                });
            }
        });

        $(document).on('click', '.js-notify-popup-link:not(.final-sale)', e => {
            e.preventDefault();
      
            const $currentTarget = $(e.currentTarget);
            
            _this
              .loadProductNotify($currentTarget.data('url'))
              .then(data => {
                if (!data) { return; }
                const html = data.html;
                $('.js-notify-popup').html(html.content);

                if (!$('.fancybox-active').length) {
                    $.fancybox.open($('.js-notify-popup'), {
                      baseClass: `notify-popup__lightbox product-${$currentTarget.data('id')}`,
                      hash: false,
                      infobar : false,
                      toolbar: false,
                      loop: false,
                      smallBtn : true,
                      video: {
                        autoStart: false
                      },
                      touch: false,
                      mobile: {
                        preventCaptionOverlap: false,
                        toolbar: true,
                        buttons: [
                          "close"
                        ]
                      },
                      beforeLoad: () => {
                        if ($currentTarget.data('selected-variant')) {
                            $selected = $('.js-notify-popup').find('.swatch-element[data-id="'+ $currentTarget.data('selected-variant') +'"]');
                            $selected.prev('input[type="radio"]').prop('checked', true);
                            $selected.trigger('click');
                        }
                        productPage.productSwatches();
                        window.bodyScrollLock.lockscroll();
                        const productForm = $currentTarget.closest('form');
                        var selectedGender = productForm.find('.gender-swatch input[name="properties[Gender]"]:checked').val();
                        if (selectedGender) {
                            $('.js-notify-popup').find('.gender-swatch input[name="properties[Gender]"][value="'+ selectedGender +'"]').trigger('click');
                        }
                        if ($('.notify_mobile').length > 0) {
                            $('.notify_mobile').usPhoneFormat();
                        }
                      },
                      afterShow: (_e, instance) => {
                        // Use unique identifier for the product gallery
                        //const { src } = instance;
                        //const $quickshop = $(src).find('.quick-shop');
        
                        //$quickshop.addClass('quick-shop--loaded');
                        //$quickshop.addClass('content-loaded');
                      },
                      beforeClose: (_e, instance) => {
                        // Use unique identifier for the product gallery
                        //const { src } = instance;
                        //const $quickshop = $(src).find('.quick-shop');
        
                        //$quickshop.removeClass('quick-shop--loaded');
                        //$quickshop.removeClass('content-loaded');
                        window.bodyScrollLock.releasescroll();
                      }
                    });

                    _this.sendNotification('.notify_form');
                }

              });
        });

        $(document).on('click', '.fancybox-slide', function(event) { 
            if ($(event.target).hasClass('fancybox-slide')) {
                $('[data-fancybox-close]').trigger('click');
            }
        });

        $(document).click(function(event) { 
            if (event.target.classList.contains('country-flag-dropdown') == false && event.target.closest('.country-flag-dropdown') == null && event.target.classList.contains('list-wrapper') == false && event.target.closest('.list-wrapper') == null) {
                $('.country-flag-dropdown').removeClass('open');
            }
        });

        /* Search Country In List */
        $(document).on('keyup', 'input[name="list_search"]', function(e) {
            var searchString = $(this).val();
            $("ul.country-list li").each(function(index, value) {
                currentName = $(value).text()
                if (currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
                    $(value).show();
                } else {
                    $(value).hide();
                }
            });
        });

        /* Show phone number input when notify by sms checked */
        $(document).on('click', 'input[name="notified_by_sms"]', function() {
            var $obj = $(this),
                phoneField = $obj.closest('form').find('.phone-input');
            if ($obj.is(':checked') == true) {
                phoneField.find('.phone-input').show();
            } else {
                phoneField.find('.phone-input').hide();
            }
        });

        //this.sendNotification('.notify_form');
    },
    loadProductNotify(url) {
        return window.shopifyAsyncview.load(
          url, // Template name
          { view: 'notify' }, // View name (suffix)
        );
    },
    sendNotification: function(selector) {
        //selector = selector || '.contact-form';
        var _this = this;
        document.querySelectorAll(selector).forEach(function(form) {
            var alert = form.querySelector('[data-alert="status"]'),
                email = form.querySelector('input[name="contact[email]"]'),
                email_alert = form.querySelector('[data-alert="email-status"]'),
                phone = form.querySelector('input[type="tel"][name="contact[phone]"]'),
                hiddenphone = form.querySelector('input[type="hidden"][name="contact[phone]"]'),
                phone_alert = form.querySelector('[data-alert="phone-status"]'),
                alert_message = 'Please select size.',
                mobile = '',
                countryCode = '',
                isValid = true;
                
                // Submit data via Fetch
                form.addEventListener('submit', function(e) { 
                    e.preventDefault();
                    e.stopPropagation();
                    if (email.value == '') {
                        isValid = false;
                        email_alert.className = 'message error';
                        email_alert.innerHTML = "Please enter your email.";
                        return false;
                    }
                    var email_value = email.value;
                    if (email_value != '') {
                        var emailExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                        if (!email_value.match(emailExp)) {
                            isValid = false;
                            email_alert.className = 'message error';
                            email_alert.innerHTML = "Please enter your valid email.";
                            return false;
                        } else {
                            isValid = true;
                            email_alert.className = '';
                            email_alert.innerHTML = '';
                        }
                    }
                    
                    if (form.querySelector('.swatch_options') != null && form.querySelector('.swatch_options').length > 0 && form.querySelector('[name="option-0"]:checked') == null) {
                        isValid = false;
                        alert.className = 'message error';
                        alert.innerHTML = alert_message;
                        return false;
                    }
                    
                    if (form.querySelector('input[name="notified_by_sms"]:checked') == null) {
                        form.querySelector('input[name="contact[phone]"]').value = '';
                    }
                    if (form.querySelector('input[name="notified_by_sms"]:checked') != null) {
                        //var selectedCountry = $('.country-list li.selected').data('code'),
                        //countryCode = phone.value.substring(0, selectedCountry.length);
                        //mobile = phone.value.substring(selectedCountry.length); 
                        countryCode = $('.country-list li.selected').data('code');
                        mobile = phone.value;
                        if (mobile != '') {
                            //var phoneno = /^[0-9]{10}$/;
                            var phoneno = /(([2-9]\d{2}-\d{3}-\d{4})|(\([2-9]\d{2}\)-\d{3}-\d{4})|([2-9]\d{2}\.\d{3}\.\d{4}))([xX]\d{1,4})?/g;
                            if (!mobile.match(phoneno)) {
                                isValid = false;
                                phone_alert.className = 'message error';
                                phone_alert.innerHTML = 'Please enter valid mobile number.';
                                return false;
                            } else {
                                isValid = true;
                                phone_alert.className = '';
                                phone_alert.innerHTML = '';
                            }
                        } else {
                            isValid = true;
                            phone_alert.className = '';
                            phone_alert.innerHTML = '';
                        }
                    }
                    
                    if (isValid) { 
                        if (mobile == '') { 
                            hiddenphone.value = '';
                        } else {
                            hiddenphone.value = countryCode + ' ' + mobile;
                        }
                        e.currentTarget.submit();

                    }
                }, true);
        });
    }
}

/*============================================================================
  Rise Accordian
==============================================================================*/
window.riseAccordian = {
    init: function() {
      	var firstItem = $('.product-features .toggle-wrap:first');
      	$(firstItem).find('.trigger').addClass('active');
      	$(firstItem).find('.toggle-container').show();
        $(document).on('click', '.trigger', function(e) {
            e.preventDefault();
            var $this = $(this);
            if ($this.hasClass('active')) {
                $this.removeClass('active');
                $this.next('.toggle-container').slideUp(300);
            } else {
                $('.trigger').removeClass('active');
                $('.toggle-container').slideUp(300);
                $this.addClass('active');
                $this.next('.toggle-container').slideToggle(300);
            }
        });
    }
}

/*============================================================================
  Rise Cart Fixed
==============================================================================*/
window.riseCartFixed = {
    init: function() {
        var e = this;
        $(document).on('scroll', function() {
            if ($(window).width() > 798) {
                e.showCartFixed();
            }
        });
        $(document).ready(function() { 
            if ($('body').hasClass('product')) {
                $selectedOption = $('.product .product-block--form .swatch_options input[name="option-0"]:checked').next('.swatch-element');
                var size_id = $selectedOption.data('id');
                $('.rise-add-to-cart-fixed .swatch_options .swatch-element[data-id="'+ size_id +'"]').prev('input[type="radio"]').prop('checked', true);
                e.adjustPageBottom();
            }
        });
        $(window).resize(function() {
            if ($('body').hasClass('product')) {
                e.adjustPageBottom();
            }
        });
    },
    showCartFixed: function() {
        var $body = $('body'),
        $productCTA = $('body.product').find('.product-main .purchase-details');
        if ($body.hasClass('product') && $productCTA.length > 0) {
            if ($(window).scrollTop() >= ($productCTA.offset().top - 60)) {
                if (!$body.hasClass('has-rise-cart-fixed')) $body.addClass('has-rise-cart-fixed');
                $('#reamaze-widget').addClass('floating-icon');
            } else {
                if ($body.hasClass('has-rise-cart-fixed')) $body.removeClass('has-rise-cart-fixed');
                $('#reamaze-widget').removeClass('floating-icon');
            }
        }
    },
    adjustPageBottom: function() {
        $('body.product').css('margin-bottom', $('.rise-add-to-cart-fixed').height() + 'px');
    }
}

/*============================================================================
  Account Address Events
==============================================================================*/
window.accountAddressEvents = {
    init: function() {
        $(document).on('click', '.account-form .action_edit, .account-form .action_add', function() {
            $(this).parents('.account-form').addClass('show-form');
            var active_form  = $('.address-form .customer_address[style*="display: none"]').length,
            total_form = $('.address-form .customer_address').length;
            if (active_form == total_form) {
                $(this).parents('.account-form').removeClass('show-form');
            }
        });
        
        $(document).on('click', '.account-form .action_bottom .note a', function() {
            var active_form  = $('.address-form .customer_address[style*="display: none"]').length,
            total_form = $('.address-form .customer_address').length;
            if (active_form == total_form) {
                $(this).parents('.account-form').removeClass('show-form');
            }
        });
    }
}

/*============================================================================
  Header Search
==============================================================================*/
window.headerSearch = {
    init: function() {
        $('input[name="q"]').keyup(function(e) {
            if (e.which == 40) {
              if ($('.search__results li.selected').length!=0) {
                var storeTarget	= $('.search__results').find('li.selected').next();
                if (!storeTarget.hasClass('all-results')) {
                  $('.search__results li.selected').removeClass('selected');
                  storeTarget.focus().addClass('selected');
                  storeTarget.closest('.search__results').scrollTop(storeTarget.index() * (storeTarget.outerHeight() - 40));
                } else {
                  storeTarget.closest('.search__results').scrollTop(storeTarget.index() * storeTarget.outerHeight());
                }
              } else {
                $('.search__results').find('li.item-result:first').focus().addClass('selected');
              }
              return;
            } else {
              if (e.which == 38) {
                var storeTarget	= $('.search__results').find('li.selected').prev();
                if (!storeTarget.hasClass('search-info')) {
                  $('.search__results li.selected').removeClass('selected');
                  storeTarget.focus().addClass('selected');
                  if (storeTarget.prev().hasClass('search-info')) {
                    storeTarget.closest('.search__results').scrollTop(0);
                  } else {
                    storeTarget.closest('.search__results').scrollTop(storeTarget.index() * (storeTarget.outerHeight() - 40));
                  }
                }
              }
              return;
            }
        });
        
        $('input[name="q"]').keydown(function(e) {
            if ((e.metaKey && e.which == 13) || (e.ctrlKey && e.which == 13)) {
              e.preventDefault();
              if ($('.search__results li.selected').length) {
                window.open(
                  $('.search__results li.selected a').attr('href'),
                  '_blank'
                );
              }
            } else {
              if (e.which == 13) {
                e.preventDefault();
                if ($('.search__results li.selected').length) {
                  window.location.href = $('.search__results li.selected a').attr('href');
                } else {
                  $(this).closest('form').submit();
                }
              }
            }
        });

        $('.search-container .search__results').scroll(function() {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
              $('.search-container .search__results-wrapper').addClass('faded-off');
            } else {
              $('.search-container .search__results-wrapper').removeClass('faded-off');
            }
        });
    }
}

/*============================================================================
  Header Mini Cart
==============================================================================*/
window.miniCart = {
    init: function() {
        var _this = this;
        /*$(document).ready(function() {
            var header_selector = 'header .main-nav';
            if ($(window).width() <= 798) {
              header_selector = 'header.mobile_nav-fixed--true';
            }
            $(header_selector + ' .cart-container').addClass('active_link');
            if ($(header_selector + ' .cart-container.active_link .cart_items_wrapper').hasScrollBar() === true) { 
              $(header_selector + ' .cart-container.active_link .cart-summary').addClass('is-faded').removeClass('remove-faded');
            } else {
              $(header_selector + ' .cart-container.active_link .cart-summary').removeClass('is-faded').addClass('remove-faded');
            }
            $(header_selector + ' .cart-container').removeClass('active_link');
        });

        $('header .cart-container .cart_items_wrapper').on('scroll', function() { 
            var obj = $(this);
            if (obj.scrollTop() >= (obj[0].scrollHeight - obj.outerHeight() - 10)) {
              $('header .cart-container .cart-summary').addClass('remove-faded');
              $('header .cart-container.active_link .cart-summary').removeClass('is-faded');
            } else {
              $('header .cart-container .cart-summary').removeClass('remove-faded');
              $('header .cart-container.active_link .cart-summary').addClass('is-faded');
            }
        });*/

        $.fn.hasScrollBar = function() { 
            if (typeof this.get(0) !== "undefined")
              return this.get(0).scrollHeight > Math.round(this.height());
        }

        $(window).resize(function(){
            _this.enableCartFaded();
        });
    },
    enableCartFaded: function() {
        /*var header_selector = 'header .main-nav';
        if ($(window).width() <= 798) {
            header_selector = 'header.mobile_nav-fixed--true';
        } 
        if ($(header_selector + ' .cart-container.active_link .cart_items_wrapper').hasScrollBar() === true) {
            $(header_selector + ' .cart-container.active_link .cart-summary').addClass('is-faded').removeClass('remove-faded');
        } else {
            $(header_selector + ' .cart-container.active_link .cart-summary').removeClass('is-faded').addClass('remove-faded');
        }*/
    }
}

/*============================================================================
  Account Create
==============================================================================*/
window.accountCreate = {
    init: function() {
        var _this = this,
            messages = {
                firstame: {
                    required: 'Please enter your first name',
                    invalid: 'Please enter your valid first name'
                },
                lastame: {
                    required: 'Please enter your last name',
                    invalid: 'Please enter your valid last name',
                    same: 'Please enter a different first and last name'
                },
                email: {
                    required: 'Please enter your email address',
                    invalid: 'Please enter your valid email address'
                },
                password: {
                    required: 'Please enter your password',
                    invalid: 'Please enter your password between 5 to 15 characters'
                },
                agree: 'Please read & accept our terms and conditions'
            };
        $(document).on('keyup', '.register-main input', function(e) {
            var $input = $(this);
            var keyCode = e.keyCode || e.which; 
            if (keyCode == 9) {
                return false;
            }
            setTimeout(function() {
                if ($input.val() != '') { 
                    curParent = $input.parent();
                    $(curParent).removeClass('has-error');
                    $(curParent).children('#error').remove();
                    if ($input.attr('id') == 'email') {  
                        if (_this.isEmail($input.val())) {
                            $input.parent('.form-input').removeClass('has-error').addClass('filled');
                        } else {
                            $input.parent('.form-input').removeClass('filled').addClass('has-error');
                            error_message = '<span id="error" class="form-error">'+ messages.email.invalid +'</span>';
                            $(curParent).append(error_message).addClass('has-error');
                        }
                    } else if ($input.attr('id') == 'password') {
                        var flag = _this.validateLength($input.val(), 5, 15);
                        if (flag == 0) {
                            $input.parent('.form-input').removeClass('has-error').addClass('filled');
                        } else {
                            $input.parent('.form-input').removeClass('filled').addClass('has-error');
                            error_message = '<span id="error" class="form-error">'+ messages.password.invalid +'</span>';
                            $(curParent).append(error_message).addClass('has-error');
                        }
                    } else if ($input.attr('id') == 'first_name') { 
                        var flag = _this.validateName($input.val());
                        if (flag == 0) {
                            $input.parent('.form-input').removeClass('has-error').addClass('filled');
                        } else {
                            $input.parent('.form-input').removeClass('filled').addClass('has-error');
                            error_message = '<span id="error" class="form-error">'+ messages.firstame.invalid +'</span>';
                            $(curParent).append(error_message).addClass('has-error');
                        }
                    } else if ($input.attr('id') == 'last_name') { 
                        var flag = _this.validateName($input.val());
                        if (flag == 0) {
                            if ($("input[name='customer[first_name]']").val().toLowerCase() == $input.val().toLowerCase()) { 
                                $input.parent('.form-input').removeClass('filled').addClass('has-error');
                                error_message = '<span id="error" class="form-error">'+ messages.lastame.same +'</span>';
                                $(curParent).append(error_message).addClass('has-error');
                            } else {
                                $input.parent('.form-input').removeClass('has-error').addClass('filled');
                            }
                        } else {
                            $input.parent('.form-input').removeClass('filled').addClass('has-error');
                            error_message = '<span id="error" class="form-error">'+ messages.lastame.invalid +'</span>';
                            $(curParent).append(error_message).addClass('has-error');
                        } 
                    } else {
                        $input.parent('.form-input').addClass('filled');
                    }
                } else {
                    curParent = $input.parent();
                    $(curParent).removeClass('has-error');
                    $(curParent).children('#error').remove();
                    if ($input.attr('id') == 'first_name') { 
                        $input.parent('.form-input').removeClass('filled').addClass('has-error');
                        error_message = '<span id="error" class="form-error">'+ messages.firstame.required +'</span>';
                        $(curParent).append(error_message).addClass('has-error');
                    } else if ($input.attr('id') == 'last_name') { 
                        $input.parent('.form-input').removeClass('filled').addClass('has-error');
                        error_message = '<span id="error" class="form-error">'+ messages.lastame.required +'</span>';
                        $(curParent).append(error_message).addClass('has-error');
                    } else if ($input.attr('id') == 'email') { 
                        $input.parent('.form-input').removeClass('filled').addClass('has-error');
                        error_message = '<span id="error" class="form-error">'+ messages.email.required +'</span>';
                        $(curParent).append(error_message).addClass('has-error');
                    } else if ($input.attr('id') == 'password') { 
                        $input.parent('.form-input').removeClass('filled').addClass('has-error');
                        error_message = '<span id="error" class="form-error">'+ messages.password.required +'</span>';
                        $(curParent).append(error_message).addClass('has-error');
                    }
                }
            }, 1000);
        });
        
        $(document).on('click', '#create_customer input[type="submit"]', function(e) {
            e.preventDefault();
            var $form = $(this).parents('form');
            error = 0;
            obj = '#create_customer';
        
            first_name = $(obj + ' input#first_name').val();
            last_name = $(obj + ' input#last_name').val();
            email = $(obj + ' input#email').val();
            password = $(obj + ' input#password').val();
            accepts_marketing = $(obj + ' input[name="customer[accepts_marketing]"]');
            agree = $(obj + ' input#agree');
        
            current = obj + ' input#first_name';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            flag = _this.validateName(first_name);
            if (flag == 1 || first_name.length < 2) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.firstame.invalid +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            current = obj + ' input#last_name';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            flag = _this.validateName(last_name);
            if (flag == 1 || last_name.length < 2) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.lastame.invalid +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            if (first_name.toLowerCase() == last_name.toLowerCase()) {
                current = obj + ' input#last_name';
                curParent = $(current).parent();
                $(curParent).removeClass('has-error');
                $(curParent).children('#error').remove();
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.lastame.same +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            current = obj + ' input#email';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            flag = _this.validateEmail(email);
            if (email.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.email.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            if (email.length > 0 && flag == 1) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.email.invalid +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            current = obj + ' input#password';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            flag = _this.validateLength(password, 5, 15);
            if (password.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.password.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            if (password.length > 0 && flag == 1) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.password.invalid +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            current = obj + ' input#agree';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (!$(agree).is(':checked')) {
                error = 1;
                error_message = '<span id="error" class="form-error mt-10">'+ messages.agree +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            if (error == 0) {
              $form.submit();
              //_this.createAccount(first_name, last_name, email, password, accepts_marketing);
            }
        });        
    },
    createAccount: function(firstName, lastName, email, password, accepts_marketing) {
        
        
        var escapedData = {
            firstName: escape(firstName),
            lastName: escape(lastName),
            email: escape(email),
            password: escape(password).replace(/\+/g, '%2B'),
        }
        var data = 'form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=';
        data += escapedData.firstName;
        data += '&customer%5Blast_name%5D=';
        data += escapedData.lastName;
        data += '&customer%5Bemail%5D=';
        data += escapedData.email;
        data += '&customer%5Bpassword%5D=';
        data += escapedData.password;
        if (accepts_marketing.is(':checked')) {
            data += '&customer%5Baccepts_marketing%5D=true';
        }
        jQuery.post('/account', data)
            .done(function(response){ 
                var logErrors = jQuery(response).find('.errors').text();
                if (logErrors != '' && logErrors != 'undefined'){
                    $.fancybox.open($('.signup-success-popup'), {
                        baseClass: `js-signup-success__lightbox`,
                        hash: false,
                        infobar : false,
                        toolbar: false,
                        loop: false,
                        smallBtn : true,
                        video: {
                          autoStart: false
                        },
                        touch: false,
                        mobile: {
                          preventCaptionOverlap: false,
                          toolbar: true
                        },
                        beforeLoad: () => {
                          window.bodyScrollLock.lockscroll();
                        },
                        afterShow: function() {
                            logErrors = logErrors.replace('reset your password', 'reset your password <a href="/account/login#recover">here</a>');
                            $('.js-signup-success__lightbox').find('.message').html(logErrors);
                            $('.js-signup-success__lightbox p').hide();
                        },
                        afterClose: function() {
                          window.bodyScrollLock.releasescroll();
                        }
                    });
                } else {
                    $.fancybox.open($('.signup-success-popup'), {
                        baseClass: `js-signup-success__lightbox`,
                        hash: false,
                        infobar : false,
                        toolbar: false,
                        loop: false,
                        smallBtn : true,
                        video: {
                          autoStart: false
                        },
                        touch: false,
                        mobile: {
                          preventCaptionOverlap: false,
                          toolbar: true
                        },
                        beforeLoad: () => {
                          window.bodyScrollLock.lockscroll();
                        },
                        afterShow: function() {
                            $('#create_customer')[0].reset();
                            $('.js-signup-success__lightbox').find('.message').html('We have sent an email to ' + escapedData.email + ', please click the link included to verify your account.');
                            $('.js-signup-success__lightbox p').show();
                        },
                        afterClose: function() {
                          window.bodyScrollLock.releasescroll();
                        }
                    });
                }
            }).fail(function() {
                alert('error could not submit');
            });
        return false;
    },
    validateEmail: function(inputtext) {
        var emailExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (inputtext.match(emailExp)) {
            return 0;
        } else {
            return 1;
        }
    },
    validateName: function(inputtext) {
        var alphaExp = /^[a-zA-Z- ]+$/;
        if (inputtext.match(alphaExp)) {
            return 0;
        } else {
            return 1;
        }
    },
    validateLength: function(inputtext, min, max) {
        var uInput = inputtext;
        if (uInput.length >= min && uInput.length <= max) {
            return 0;
        } else {
            return 1;
        }
    },
    isEmail: function(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }
}

/*============================================================================
  Header Mini Cart
==============================================================================*/
window.featuredPromationsSlider = {
    init: function() {
        var _this = this,
        $slider = $('.featured-promotions-mobile-slider'),
        isFlickity = false;
        if ($(window).width() <= 798) { 
            isFlickity = true;
            $slider.flickity({
                "lazyLoad": 2,
                "imagesLoaded": true,
                "cellAlign": 'left',
                "wrapAround": true,
                "prevNextButtons": false,
                "pageDots": false
            });
            $slider.find('.feature-section').addClass("pageloaded");
        } else {
            isFlickity = false;
        }

        $(window).resize(function() {
            if ($(window).width() <= 798) { 
                isFlickity = true;
                $slider.flickity({
                    "lazyLoad": 2,
                    "imagesLoaded": true,
                    "cellAlign": 'left',
                    "wrapAround": true,
                    "prevNextButtons": false,
                    "pageDots": false
                });
                $slider.find('.feature-section').addClass("pageloaded");
            } else {
              if (isFlickity)
                $slider.flickity('destroy');
            }
        });
    }
}

/*============================================================================
  Live Refresh Cart Properties
==============================================================================*/
window.liveRefreshCart = {
    init: function() {
        $(document).ready(function() { 
            var cartItems = [];
            $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                async: false,
                success(cart) {
                    if (cart.items.length > 0) {
                        $.each(cart.items, function (i, value) {
                            cartItems[value.variant_id] = value.properties;
                        });
                    }
                }
            });
            var selector = 'header.search-enabled--true .tos_warning .js-cart_items .mini-cart__item',
                metaSelector = '.line-item.status',
                isPage = '';
            if ($('body').hasClass('cart')) {
                selector = '#cart_form .cart__item-list .cart__item';
                metaSelector = '.meta-item.status';
                isPage = 'cart';
            }
            $(selector).each(function() {
                var $meta = $(this).find('.product-meta'),
                    line_id = $(this).data('line-id'),
                    variant_id = $(this).data('variant-id'),
                    quantity = $(this).find('[data-cart-quantity-input]').val(),
                    data = {};
                if ($meta.find(metaSelector).length > 0) {
                    var currentStatus = $.trim($meta.find(metaSelector).html());
                    if (isPage == 'cart') {
                        currentStatus = $.trim($meta.find(metaSelector).data('status'));
                    }
                    if (currentStatus != cartItems[variant_id].Status) {
                        if (currentStatus == '') {
                            data = {
                                Status: null
                            };
                        } else {
                            data = {
                                Status: currentStatus
                            };
                        }
                    }
                } else { 
                    if (cartItems[variant_id] != null && typeof cartItems[variant_id].Status !== 'undefined' && cartItems[variant_id].Status != '') {
                        data = {
                            Status: null
                        };
                        data = null;
                    }
                } 
                if (typeof data !== 'undefined' && Object.entries(data).length > 0) {
                    jQuery.ajax({
                        url: '/cart/change.js',
                        dataType: 'json',
                        cache: false,
                        type: 'post',
                        data: {
                            properties: data,
                            line: line_id,
                            quantity: quantity
                        },
                        success: function() {
                        }
                    });
                }
            });
        });
    }
}
/*window.liveRefreshCart = {
    init: function() {
        $(document).ready(function() { 
            $('.tos_warning .js-cart_items .mini-cart__item').each(function() {
                var restockDate = $(this).data('restock-date'),
                    data = {},
                    variant_id = $(this).data('variant-id'),
                    line_no = $(this).data('line-id');
                if (restockDate != '') {
                    data = {
                        "Status": "Pre-order",
                        "Restock date": restockDate
                    };
                } else {
                    data = {
                        "Status": "",
                        "Restock date": ""
                    };
                } console.log(restockDate);
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {
                        "id": variant_id,
                        "quantity": 20,
                        //"properties": data
                    },
                    async: false,
                    cache: false,
                    dataType: 'json',
                    success: function() {
                        if (restockDate == '') {
                            $('.js-cart_items .mini-cart__item[data-restock-date="' + restockDate + '"] .product-meta .line-item.status, .js-cart_items .mini-cart__item[data-restock-date="' + restockDate + '"] .product-meta .line-item.restock-date, body.cart .cart__item-list .cart__item[data-variant-id="'+ variant_id +'"] .product-meta .meta-item:not(.size)').remove();
                        } else { 
                            $('.js-cart_items .mini-cart__item[data-restock-date="' + restockDate + '"] .product-meta .line-item.status, .js-cart_items .mini-cart__item[data-restock-date="' + restockDate + '"] .product-meta .line-item.restock-date, body.cart .cart__item-list .cart__item[data-variant-id="'+ variant_id +'"] .product-meta .meta-item:not(.size)').remove();
                            $('.js-cart_items .mini-cart__item[data-restock-date="' + restockDate + '"] .product-meta').append('<div class="line-item status"> Pre-order</div><div class="line-item restock-date"> ≈ '+ restockDate +'</div>');
                            $('body.cart .cart__item-list .cart__item[data-variant-id="'+ variant_id +'"] .product-meta').append('<div class="meta-item">Status: Pre-order</div><div class="meta-item"> Restock date: '+ restockDate +'</div>');
                        }
                    }
                });
            });
        });
    }
}*/

/*============================================================================
  Sticky Mobile Checkout
==============================================================================*/
window.stickyMobileCheckout = {
    init: function() {
        if ($('.sticky-checkout-mobile').length <= 0) return false;
        var _this = this;
        _this.cartFaded();
        $(window).resize(function() {
            _this.cartFaded();
        });

        $(document).on('scroll', function() {
            if ($(this).scrollTop() + $(window).height() >= $('.cart-summary').position().top) {
                $('.sticky-checkout-mobile').addClass('faded-off');
            } else {
                $('.sticky-checkout-mobile').removeClass('faded-off');
            }
        });
    },
    cartFaded: function() {
        if ($(window).height() <= $('.cart-summary').position().top) {
            $('.sticky-checkout-mobile').removeClass('faded-off');
        } else {
            $('.sticky-checkout-mobile').addClass('faded-off');
        }
    }
}

/*============================================================================
  Country Dropdown With Flag
==============================================================================*/
window.countryDropdownFlag = {
    init: function() {

        $('.country-list li').removeClass('selected');
        if (window.Shopify.domain == 'www.risestore.ca') {
            $('.country-list li[data-value="CA"]').addClass('selected');
        } else {
            $('.country-list li[data-value="US"]').addClass('selected');
        }

        $(document).on('click', '.country-flag-dropdown', function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                $(this).parent('.group-control').find('input[name="list_search"]').focus();
            } else {
                $(this).parent('.group-control').find('input[name="contact[phone]"]').focus();
            }
        });
    
        $(document).on('click', '.country-list li', function(e) {
            var obj = $(this);
                $inputGroup = $(obj).parents('.group-control'),
                $mobileInput = $inputGroup.find('input[name="contact[phone]"]'),
                value = '#' + $(obj).data('value');
            $('.country-list li').removeClass('selected');
            $(obj).addClass('selected');
            $inputGroup.find('.selected svg use').attr('xlink:href', value);
            //if ($(obj).data('code') == $inputGroup.find('input[name="contact[phone]"]').data('code')) {
                //$mobileInput.val($mobileInput.data('mobile-no'));
                //$inputGroup.find('.selected .dail-code').html($(obj).data('code'));
            //} else {
                //$mobileInput.val($(obj).data('code'));
                $inputGroup.find('.selected .dail-code').html($(obj).data('code'));
            //}
            $inputGroup.find('.country-flag-dropdown').removeClass('open');
            $(this).parents('.list-wrapper').next('input[name="contact[phone]"]').focus();
        });
    }
}

/*============================================================================
  Rise Cookie
==============================================================================*/
window.riseCookie = {
    setCookie: function(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    getCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    eraseCookie: function(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

/*============================================================================
  Rise UI Toaster Notification
==============================================================================*/
window.riseToaster = {
    init: function() {
        var _this = this, 
        hideToasterTime,
        $toaster = $('.rise-toaster'),
        is_submitted_form = window.riseBase.getUrlParameter('contact_posted');
        if (is_submitted_form == 'true') {
            $toaster.addClass('active');
            let url = new URL(window.location);
            let params = new URLSearchParams(url.search);
            params.delete('contact_posted');
            if (params.toString() != '') {
                window.history.pushState({}, '', '?' + params.toString());
            } else {
                window.history.pushState({}, '', location.href.split('?')[0]);
            }
            _this.hideToaster($toaster, hideToasterTime);
        } else {
            if ($toaster.hasClass('active')) {
                _this.hideToaster($toaster, hideToasterTime);
            }
        }
        $toaster.on('click', '.close', function(e) {
            e.preventDefault();
            $toaster.removeClass('active');
        });
        $toaster.mouseenter(function() {
            clearTimeout(hideToasterTime);
        }).mouseleave(function() {
            _this.hideToaster($toaster, hideToasterTime);
        });
    },
    hideToaster: function($toaster, hideToasterTime) {
        hideToasterTime = setTimeout(function() {
            $toaster.removeClass('active');
        }, 3000);
    }
}

/*============================================================================
  Rise Country Switcher
==============================================================================*/
window.riseCountrySwitcher = {
    init: function() {
        var _this = this;
        _this.setDefaultStore();
        const arrowHtml = '<span class="disclosure-arrow">' + $('.selected-store .disclosure-arrow').clone().html() + '</span>';

        $(document).on('click', '#store-list a[href="javascript:void(0)"]', function() {
            localStorage.setItem('store-locator', $(this).find('img').attr('title'));
            $('.disclosure__toggle--store .selected-store').html($(this).html() + arrowHtml);
            let url = new URL(window.location);
            let params = new URLSearchParams(url.search);
            params.delete('store');
            if (params.toString() != '') {
                window.history.pushState({}, '', '?' + params.toString());
            }
            $(this).parents('.disclosure--store').find('.disclosure__toggle--store').removeClass('is-clicked');
        });
        $(document).on('click', '#store-list a:not([href="javascript:void(0)"])', function(e) {
            e.preventDefault();
            $('.disclosure__toggle--store .selected-store').html($(this).html() + arrowHtml);
            $(this).parents('.disclosure--store').find('.disclosure__toggle--store').removeClass('is-clicked');
            window.location.href = $(this).attr('href');
        });
    },
    setDefaultStore: function() {
        var store = window.riseBase.getUrlParameter('store');
        if (store) {
            if (store == 'usa') {
                localStorage.setItem('store-locator', 'Rise USA');
            } else if (store == 'world') {
                localStorage.setItem('store-locator', 'Rise Internation');
            }
        }
        var currentStore = localStorage.getItem('store-locator');
        if (currentStore !=  null && currentStore != 'Rise Canada') {
            $('#store-list li a img[title="'+ currentStore +'"]').parent('a').trigger('click');
        }
    }
}

/*============================================================================
  Rise Product Sale Countdown
==============================================================================*/
window.productSaleCountDown = {
    init: function() {
        if ($('body').hasClass('product') || $('body').hasClass('product-product-and-landing-page1')) {
            
            function convertTimezone(date, timezoneString) {
                return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: timezoneString}));
            }

            if (show_timer == true && $.trim(timer) != '') {
                var convertedDate = convertTimezone(timer.replaceAll('-', '/') + " -0500", Intl.DateTimeFormat().resolvedOptions().timeZone);
                var convertedDateString =
                convertedDate.getFullYear() + "/" +
                ("00" + (convertedDate.getMonth() + 1)).slice(-2) + "/" +
                ("00" + convertedDate.getDate()).slice(-2) + " " +
                ("00" + convertedDate.getHours()).slice(-2) + ":" +
                ("00" + convertedDate.getMinutes()).slice(-2) + ":" +
                ("00" + convertedDate.getSeconds()).slice(-2);
                
                $('#r2020_view_1_countdownA').countdown(convertedDateString.toString(), function(event) {
                    var czas = event.strftime('%D|%H|%M|%S');
                    var result = czas.split('|');
                    
                    var day = result['0'];
                    $('.day-digit-1').html(day['0']);
                    $('.day-digit-2').html(day['1']);
          
                    var hour = result['1'];
                    $('.hour-digit-1').html(hour['0']);
                    $('.hour-digit-2').html(hour['1']);
          
                    var mintues = result['2'];
                    $('.mintues-digit-1').html(mintues['0']);
                    $('.mintues-digit-2').html(mintues['1']);
          
                    var seconds = result['3'];
                    $('.seconds-digit-1').html(seconds['0']);
                    $('.seconds-digit-2').html(seconds['1']);
          
                });
            }
        }
    }
}

/*============================================================================
  Password Page Countdown
==============================================================================*/
window.passwordCountdown = {
    init: function() {
        //if (!$('body').hasClass('password') || password_timer == ' ') return false;
        if ($('.shopify-section--rise-video').length == 0 && $('.video-background').length == 0 || password_timer == ' ') return false;
        var convertedDate = this.convertTimezone(password_timer.replaceAll('-', '/') + " -0500", Intl.DateTimeFormat().resolvedOptions().timeZone);
        /*console.log(password_timer);
        const date = new Date(password_timer);
        console.log(
            new Intl.DateTimeFormat('en-US', {
              dateStyle: 'full',
              timeStyle: 'long',
              timeZone: 'America/New_York',
            }).format(date),
          );*/

        /*const date = new Date(password_timer);
        var intlDateObj = new Intl.DateTimeFormat('en-US', {timeZone: "America/New_York"});
        var timeZoneUSA = intlDateObj.format(date);
        console.log(new Date(timeZoneUSA));*/
        /*
        const date = new Date(password_timer);
        console.log(
            date.toLocaleString('en-US', {
              timeZone: 'America/New_York',
            }),
          );*/
        var convertedDateString =
        convertedDate.getFullYear() + "/" +
        ("00" + (convertedDate.getMonth() + 1)).slice(-2) + "/" +
        ("00" + convertedDate.getDate()).slice(-2) + " " +
        ("00" + convertedDate.getHours()).slice(-2) + ":" +
        ("00" + convertedDate.getMinutes()).slice(-2) + ":" +
        ("00" + convertedDate.getSeconds()).slice(-2);
        
        $('#r2020_view_1_countdownA').countdown(convertedDateString.toString(), function(event) {
            var czas = event.strftime('%D|%H|%M|%S');
            var result = czas.split('|');
            
            var day = result['0'];
            $('.countdown-timer .day-digit-1').html(day['0']);
            $('.countdown-timer .day-digit-2').html(day['1']);

            var hour = result['1'];
            $('.countdown-timer .hour-digit-1').html(hour['0']);
            $('.countdown-timer .hour-digit-2').html(hour['1']);

            var mintues = result['2'];
            $('.countdown-timer .mintues-digit-1').html(mintues['0']);
            $('.countdown-timer .mintues-digit-2').html(mintues['1']);

            var seconds = result['3'];
            $('.countdown-timer .seconds-digit-1').html(seconds['0']);
            $('.countdown-timer .seconds-digit-2').html(seconds['1']);

        });
    },
    convertTimezone: function(date, timezoneString) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: timezoneString}));
    }
}

/*============================================================================
  Top Bar Countdown
==============================================================================*/
window.topBarCountdown = {
    init: function() {
        if ($('body').hasClass('password')) return false;
        if (show_top_bar_timer == true && $.trim(top_bar_timer) != '') {
            var convertedDate = this.convertTimezone(top_bar_timer.replaceAll('-', '/') + " -0500", Intl.DateTimeFormat().resolvedOptions().timeZone);
            var convertedDateString =
            convertedDate.getFullYear() + "/" +
            ("00" + (convertedDate.getMonth() + 1)).slice(-2) + "/" +
            ("00" + convertedDate.getDate()).slice(-2) + " " +
            ("00" + convertedDate.getHours()).slice(-2) + ":" +
            ("00" + convertedDate.getMinutes()).slice(-2) + ":" +
            ("00" + convertedDate.getSeconds()).slice(-2);
            
            $('#top_bar_countdownA').countdown(convertedDateString.toString(), function(event) {
                var czas = event.strftime('%D|%H|%M|%S');
                var result = czas.split('|');
                if(result['0'] == '00' && result['1'] == '00' && result['2'] == '00' && result['3'] == '00' ){
                    $('.on-timer-content').addClass('hidden');
                    $('.end-timer-content').removeClass('hidden');
                } else {
                    $('.on-timer-content').removeClass('hidden');
                    $('.end-timer-content').addClass('hidden');
                }
                
                var day = result['0'];
                $('.top-bar-count-down .day-digit-1').html(day['0']);
                $('.top-bar-count-down .day-digit-2').html(day['1']);
      
                var hour = result['1'];
                $('.top-bar-count-down .hour-digit-1').html(hour['0']);
                $('.top-bar-count-down .hour-digit-2').html(hour['1']);
      
                var mintues = result['2'];
                $('.top-bar-count-down .mintues-digit-1').html(mintues['0']);
                $('.top-bar-count-down .mintues-digit-2').html(mintues['1']);
      
                var seconds = result['3'];
                $('.top-bar-count-down .seconds-digit-1').html(seconds['0']);
                $('.top-bar-count-down .seconds-digit-2').html(seconds['1']);
      
            });
        }
    },
    convertTimezone: function(date, timezoneString) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: timezoneString}));
    }
}

/*============================================================================
  Rise SlideShow Countdown
==============================================================================*/
window.slideShowCountDown = {
    init: function() {
        
        if ($('.js-homepage-slideshow').length <= 0) return false;

        function convertTimezone(date, timezoneString) {
            return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: timezoneString}));
        }
        
        $('.js-homepage-slideshow').each(function() { 
            var section = $(this).attr('id');

            $('#' + section +' .gallery-cell').each(function( index ) {
                var slide = index + 1;
                if (slideshowTimer[section][index].show_timer == true && $.trim(slideshowTimer[section][index].timer) != '') {
                    var timer = slideshowTimer[section][index].timer;
                    var convertedDate = convertTimezone(timer.replaceAll('-', '/') + " -0500", Intl.DateTimeFormat().resolvedOptions().timeZone);
                    var convertedDateString =
                    convertedDate.getFullYear() + "/" +
                    ("00" + (convertedDate.getMonth() + 1)).slice(-2) + "/" +
                    ("00" + convertedDate.getDate()).slice(-2) + " " +
                    ("00" + convertedDate.getHours()).slice(-2) + ":" +
                    ("00" + convertedDate.getMinutes()).slice(-2) + ":" +
                    ("00" + convertedDate.getSeconds()).slice(-2);
                    
                    $('#' + section +' #timer-countdown__' + slide).countdown(convertedDateString.toString(), function(event) {
                        var czas = event.strftime('%D|%H|%M|%S');
                        var result = czas.split('|');
                        
                        var day = result['0'];
                        $('#' + section +' .sale-count-down--'+ slide +' .day-digit-1').html(day['0']);
                        $('#' + section +' .sale-count-down--'+ slide +' .day-digit-2').html(day['1']);
            
                        var hour = result['1'];
                        $('#' + section +' .sale-count-down--'+ slide +' .hour-digit-1').html(hour['0']);
                        $('#' + section +' .sale-count-down--'+ slide +' .hour-digit-2').html(hour['1']);
            
                        var mintues = result['2'];
                        $('#' + section +' .sale-count-down--'+ slide +' .mintues-digit-1').html(mintues['0']);
                        $('#' + section +' .sale-count-down--'+ slide +' .mintues-digit-2').html(mintues['1']);
            
                        var seconds = result['3'];
                        $('#' + section +' .sale-count-down--'+ slide +' .seconds-digit-1').html(seconds['0']);
                        $('#' + section +' .sale-count-down--'+ slide +' .seconds-digit-2').html(seconds['1']);
            
                    });
                }
            });
        });
    }
}

/*============================================================================
  Rise Subscribe From Password
==============================================================================*/
window.subscribeFromPassword = {
    init: function() {
        var _this = this;
        $(document).on('click', '.newsletter_section .newsletter-form__sign-up', function(event) {
            event.preventDefault();
            var valid = true,
                $error = $('.newsletter_section .error');
                $email = $('.newsletter_section input[type="email"]');
            
            $error.html('');
            if ($email.val() == '') {
                valid = false;
                $error.html('Please enter your email.');
            } else if (_this.validateEmail($email.val())) {
                valid = false;
                $error.html('Please enter a valid email.');
            }

            if (valid) {
                $(this).closest('form').submit();
            }
        });
    },
    validateEmail: function(inputtext) {
        var emailExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (inputtext.match(emailExp)) {
            return 0;
        } else {
            return 1;
        }
    }
}


/*============================================================================
  Rise Password Notify Popup
==============================================================================*/
window.PasswordNotifyPopup = {
    init: function() {
        var _this = this;

        $(document).on('click', '.open-rise-form[data-membership], .shopify-section--rise-membership-form .rise-form-field', function(e) {
            e.preventDefault();
            var $button = $(this);
            $.ajax({
                type: 'GET',
                url: `/?sections=rise-membership-popup`,
                success(data) {
                    var dataHtml = data['rise-membership-popup'];
                    
                    //$('[data-rise-popup]').html($(dataHtml).html());
                    var $modalEl = $button.closest('.shopify-section').find('[data-rise-popup]');
                    $modalEl.html($(dataHtml).html());

                    if (!$('.fancybox-active').length) {
                        $.fancybox.open($modalEl, {
                          baseClass: `js-rise-popup-form__lightbox`,
                          hash: false,
                          infobar : false,
                          toolbar: false,
                          loop: false,
                          smallBtn : true,
                          video: {
                            autoStart: false
                          },
                          touch: false,
                          mobile: {
                            preventCaptionOverlap: false,
                            toolbar: true
                          },
                          beforeLoad: () => {
                            window.bodyScrollLock.lockscroll();
                          },
                          afterShow: function(instance, current) {
                            /*instance.focus();
                            var self = current.$content;

                            let cardNumber = self.find('[for="cardNumber"]');
                            let cardDay = self.find('[data-card-day]');
                            let cardMonth = self.find('[data-card-month]');
                            let cardYear = self.find('[data-card-year]');
                            
                            var cardNumberDigit = Math.floor(10000000 + Math.random() * 90000000);
                            let cardNumberArr = Array.from(cardNumberDigit.toString().split(''));
                            $.each(cardNumberArr, function(index, digit) {
                                if (index < 4) {
                                    cardNumber.find('span[data-number-index="'+ (index + 1) +'"] .card-item__numberItem').html(digit);
                                } else {
                                    cardNumber.find('span[data-number-index="'+ (index + 9) +'"] .card-item__numberItem').html(digit);
                                }
                            });

                            let date = new Date();
                            date.setDate(date.getDate() + 14); 
                            let day = date.getDate();
                            let month = date.getMonth() + 1;
                            let year = date.getFullYear();
                            cardDay.find('span').html(day < 10 ? '0'+ day : day);
                            cardMonth.find('span').html(month < 10 ? '0'+ month : month);
                            cardYear.find('span').html(year);

                            if (self.find('.notify_mobile').length > 0) {
                                self.find('.notify_mobile').usPhoneFormat();
                            }
                            if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                if (self.find('input[name="contact[gender]"]').val() == '') {
                                    self.find('.rise-select-dropdown.gender .selected').trigger('click');
                                }
                            } else if (self.find('input[name="contact[email]"]').val() != '') {
                                if (self.find('input[name="contact[birth_day]"]').val() == '') {
                                    self.find('.rise-select-dropdown.days .selected').trigger('click');
                                }
                            }
                            self.find('.rise-select-dropdown').each(function() {
                                $obj = $(this);
                                var selectedValue = $obj.find('input[type="hidden"]').val();
                                if (selectedValue) {
                                    selectedValue = $obj.find('li[data-value="'+ selectedValue +'"]').html();
                                    $obj.find('.selected > span:first-child').html(selectedValue);
                                }
                            });
                            self.find('.input-badge[data-input-badge]').html($button.data('badge'));
                            if (self.find('.input-badge[data-input-badge]').html() == '') {
                                self.find('.input-badge[data-input-badge]').addClass('hide');
                            }
                            if (self.find('.popup_notify_form__inputs').hasClass('customer--true') && $button.data('non-empty') == false) {
                                if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                    self.find('.birthdate-input').remove();
                                }
                                if (self.find('input[name="contact[gender]"]').val() != '') {
                                    self.find('.gender-input').remove();
                                }
                            }
                            var dd = self.find('.rise-select-dropdown.year');
                            if (dd) {
                                dd.find('.options').show();
                                var ele = dd.get(0); 
                                ele.querySelector('.options li[data-value="1990"]').scrollIntoView();
                                dd.find('.options').hide();
                            }*/
                          },
                          afterClose: function() {
                            window.bodyScrollLock.releasescroll();
                          }
                        });

                        var self = $.fancybox.getInstance().current.$content;
                        var requiredFields = self.data('required-fields');
                        if (requiredFields) {
                            $.each(requiredFields, function(index, field) {
                                if (field == true) {
                                    if (index == 'birthday') {
                                        self.find('.birthdate-input label').append('*');
                                    } else {
                                        self.find(`.${index}-input label`).append('*');
                                    }
                                }   
                            });
                        }
                        
                        let cardNumber = self.find('[for="cardNumber"]');
                        let cardDay = self.find('[data-card-day]');
                        let cardMonth = self.find('[data-card-month]');
                        let cardYear = self.find('[data-card-year]');
                        
                        var cardNumberDigit = Math.floor(10000000 + Math.random() * 90000000);
                        let cardNumberArr = Array.from(cardNumberDigit.toString().split(''));
                        $.each(cardNumberArr, function(index, digit) {
                            if (index < 4) {
                                cardNumber.find('span[data-number-index="'+ (index + 1) +'"] .card-item__numberItem').html(digit);
                            } else {
                                cardNumber.find('span[data-number-index="'+ (index + 9) +'"] .card-item__numberItem').html(digit);
                            }
                        });

                        let date = new Date();
                        date.setDate(date.getDate() + 14); 
                        let day = date.getDate();
                        let month = date.getMonth() + 1;
                        let year = date.getFullYear();
                        cardDay.find('span').html(day < 10 ? '0'+ day : day);
                        cardMonth.find('span').html(month < 10 ? '0'+ month : month);
                        cardYear.find('span').html(year);

                        if (self.find('.notify_mobile').length > 0) {
                            self.find('.notify_mobile').usPhoneFormat();
                        }
                        if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                            if (self.find('input[name="contact[gender]"]').val() == '') {
                                self.find('.rise-select-dropdown.gender .selected').trigger('click');
                            }
                        } else if (self.find('input[name="contact[email]"]').val() != '') {
                            if (self.find('input[name="contact[birth_day]"]').val() == '') {
                                self.find('.rise-select-dropdown.days .selected').trigger('click');
                            }
                        }
                        self.find('.rise-select-dropdown').each(function() {
                            $obj = $(this);
                            var selectedValue = $obj.find('input[type="hidden"]').val();
                            if (selectedValue) {
                                selectedValue = $obj.find('li[data-value="'+ selectedValue +'"]').html();
                                $obj.find('.selected > span:first-child').html(selectedValue);
                            }
                        });
                        var id = 'notified_by_sms_' + Math.floor(Math.random() * 10);
                        self.find('[name="notified_by_sms"]').attr('id', id);
                        self.find('[name="notified_by_sms"]').next('label').attr('for', id);
                        
                        self.find('.input-badge[data-input-badge]').html($button.data('badge'));
                        if (self.find('.input-badge[data-input-badge]').html() == '') {
                            self.find('.input-badge[data-input-badge]').addClass('hide');
                        }
                        if (self.find('.popup_notify_form__inputs').hasClass('customer--true') && $button.data('non-empty') == false) {
                            if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                self.find('.birthdate-input').remove();
                            }
                            if (self.find('input[name="contact[gender]"]').val() != '') {
                                self.find('.gender-input').remove();
                            }
                        }
                        var dd = self.find('.rise-select-dropdown.year');
                        if (dd) {
                            dd.find('.options').show();
                            var ele = dd.get(0); 
                            ele.querySelector('.options li[data-value="1990"]').scrollIntoView();
                            dd.find('.options').hide();
                        }
                    }
                }
            });
        });

        $(document).on('click', '.open-rise-form[data-form], .shopify-section--rise-form .rise-form-field', function(e) {
            e.preventDefault();
            var $button = $(this);
            $button.parents('.rise-form').find('.rise-form-field').focus();
            $.ajax({
                type: 'GET',
                //url: `/pages/rise-form?view=popup`,
                url: `?sections=section-rise-form`,
                success(data) {
                    var html = data['section-rise-form'];
                    //var html = $(data).find('[data-html="content"]').clone();
    
                    //$('[data-rise-popup]').html(html.html());
                    var $modalEl = $button.closest('.shopify-section').find('[data-rise-popup]');
                    //$modalEl.html(html.html());
                    $modalEl.html(html);
                    
                    if (!$('.fancybox-active').length) {
                        $.fancybox.open($modalEl, {
                          baseClass: `js-rise-popup-form__lightbox`,
                          hash: false,
                          infobar : false,
                          toolbar: false,
                          loop: false,
                          smallBtn : true,
                          video: {
                            autoStart: false
                          },
                          touch: false,
                          mobile: {
                            preventCaptionOverlap: false,
                            toolbar: true
                          },
                          beforeLoad: () => {
                            window.bodyScrollLock.lockscroll();
                          },
                          afterShow: (instance, current) => {
                            /*instance.focus();
                            var self = current.$content;
                            
                            var email = self.find('input[name="contact[email]"').val();
                            self.find('input[name="contact[email]"').val('');
                            self.find('input[name="contact[email]"').focus().val(email);

                            if (self.find('.notify_mobile').length > 0) {
                                self.find('.notify_mobile').usPhoneFormat();
                            }
                            if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                if (self.find('input[name="contact[gender]"]').val() == '') {
                                    self.find('.rise-select-dropdown.gender .selected').trigger('click');
                                }
                            } else if (self.find('input[name="contact[email]"]').val() != '') {
                                if (self.find('input[name="contact[birth_day]"]').val() == '') {
                                    self.find('.rise-select-dropdown.days .selected').trigger('click');
                                }
                            }
                            self.find('.rise-select-dropdown').each(function() {
                                $obj = $(this);
                                var selectedValue = $obj.find('input[type="hidden"]').val();
                                if (selectedValue) {
                                    selectedValue = $obj.find('li[data-value="'+ selectedValue +'"]').html();
                                    $obj.find('.selected > span:first-child').html(selectedValue);
                                }
                            });
                            
                            self.find('.input-badge[data-input-badge]').html($button.data('badge'));
                            if (self.find('.input-badge[data-input-badge]').html() == '') {
                                self.find('.input-badge[data-input-badge]').addClass('hide');
                            }
                            if (self.find('.popup_notify_form__inputs').hasClass('customer--true') && $button.data('non-empty') == false) {
                                if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                    self.find('.birthdate-input').remove();
                                }
                                if (self.find('input[name="contact[gender]"]').val() != '') {
                                    self.find('.gender-input').remove();
                                }
                            }
                            var dd = self.find('.rise-select-dropdown.year');
                            if (dd) {
                                dd.find('.options').show();
                                var ele = dd.get(0); 
                                ele.querySelector('.options li[data-value="1990"]').scrollIntoView();
                                dd.find('.options').hide();
                            }*/
                          },
                          afterClose: function() {
                            window.bodyScrollLock.releasescroll();
                          }
                        });
                        
                        var self = $.fancybox.getInstance().current.$content;
                        var formFields = self.data('form-fields');
                        var requiredFields = self.data('required-fields');
                        if (requiredFields) {
                            $.each(requiredFields, function(index, field) {
                                if (field == true) {
                                    if (index == 'birthday') {
                                        self.find('.birthdate-input label').append('*');
                                    } else {
                                        self.find(`.${index}-input label`).append('*');
                                    }
                                }   
                            });
                        }
                        var email = self.find('input[name="contact[email]"').val();
                            self.find('input[name="contact[email]"').val('');
                            self.find('input[name="contact[email]"').focus().val(email);

                        if (self.find('.notify_mobile').length > 0) {
                            self.find('.notify_mobile').usPhoneFormat();
                        }
                        if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                            if (self.find('input[name="contact[gender]"]').val() == '') {
                                self.find('.rise-select-dropdown.gender .selected').trigger('click');
                            }
                        } else if (self.find('input[name="contact[email]"]').val() != '') {
                            if (self.find('input[name="contact[birth_day]"]').val() == '') {
                                self.find('.rise-select-dropdown.days .selected').trigger('click');
                            }
                        }
                        self.find('.rise-select-dropdown').each(function() {
                            $obj = $(this);
                            var selectedValue = $obj.find('input[type="hidden"]').val();
                            if (selectedValue) {
                                selectedValue = $obj.find('li[data-value="'+ selectedValue +'"]').html();
                                $obj.find('.selected > span:first-child').html(selectedValue);
                            }
                        });
                        var id = 'notified_by_sms_' + Math.floor(Math.random() * 10);
                        self.find('[name="notified_by_sms"]').attr('id', id);
                        self.find('[name="notified_by_sms"]').next('label').attr('for', id);
                        
                        self.find('.input-badge[data-input-badge]').html($button.data('badge'));
                        if (self.find('.input-badge[data-input-badge]').html() == '') {
                            self.find('.input-badge[data-input-badge]').addClass('hide');
                        }
                        if (formFields && formFields.birthday == false) {
                            self.find('.birthdate-input').remove();
                        }
                        if (formFields && formFields.gender == false) {
                            self.find('.gender-input').remove();
                        }
                        /*if (self.find('.popup_notify_form__inputs').hasClass('customer--true') && $button.data('non-empty') == false) {
                            if (self.find('input[name="contact[birth_day]"]').val() != '' && self.find('input[name="contact[birth_month]"]').val() != '' && self.find('input[name="contact[birth_year]"]').val() != '') {
                                self.find('.birthdate-input').remove();
                            }
                            if (self.find('input[name="contact[gender]"]').val() != '') {
                                self.find('.gender-input').remove();
                            }
                        }*/
                        var dd = self.find('.rise-select-dropdown.year');
                        if (dd) {
                            dd.find('.options').show();
                            var ele = dd.get(0); 
                            ele.querySelector('.options li[data-value="1990"]').scrollIntoView();
                            dd.find('.options').hide();
                        }
                    }
                }
            });
        });

        $(document).on('click', '.password-open-notify', function(e) {
            e.preventDefault();
            $('.rise-select-dropdown .selected').removeClass('open');
            $.fancybox.open({
                src  : '#password-notify-popup',
                type : 'inline',
                hideScrollbar: true,
                touch: true,
                mobile: {
                    modal: true,
                },
                beforeShow: function() {
                    window.bodyScrollLock.lockscroll();
                },
                afterShow: function() {
                },
                afterClose: function() {
                    window.bodyScrollLock.releasescroll();
                }
            });
        });
        $(document).on('click', 'input[name="notified_by_sms"]', function() {
            var $obj = $(this);
            _this.showMobileInput($obj);
        });
        $(document).on('click', 'button.get-early-access', function(event) {
            event.preventDefault();
            var self = $(this);
            //_this.sendEmail(self);
            _this.subscribeToMailchimp(self);
        });
        $(document).on('click', 'button.membership', function(event) {
            event.preventDefault();
            var self = $(this);
            //_this.sendEmail(self);
            _this.subscribeForMembershipCard(self);
        });
        $(document).on('click', 'button.be-vip', function(event) {
            event.preventDefault();
            var $obj = $(this);
            _this.subscribeForVIP($obj);
        });
        $(document).on('click', '.rise-toaster.dynamic .close', function(e) {
            e.preventDefault();
            $(this).parents('.rise-toaster.dynamic').removeClass('active');
        });
    },
    showMobileInput: function($obj) {
        if ($obj.is(':checked') == true) {
            $obj.parents('.notified_by_sms').next('.phone-input').show();
            $obj.parents('.notified_by_sms').next('.phone-input').next('.instruction').show();
        } else {
            $obj.parents('.notified_by_sms').next('.phone-input').hide();
            $obj.parents('.notified_by_sms').next('.phone-input').next('.instruction').hide();
        }
    },
    subscribeForVIP: function($obj) {
        var messages = {
            mobile: {
                required: 'Please enter your mobile number',
                invalid: 'Please enter your valid mobile number'
            }
        };
        var $form = $obj.parents('form'),
            error = 0;
            obj = '#vip-notify-popup form';
            
        phone = $(obj + ' input[type="tel"][name="contact[phone]"]').val();
        hiddenphone = $(obj + ' input[type="hidden"][name="contact[phone]"]');
        countryCode = $('.country-list li.selected').data('code');

        current = obj + ' .phone-input .group-control';
        curParent = $(current).parent();
        $(curParent).removeClass('has-error');
        $(curParent).children('#error').remove();
        if (phone != '') {
            var phoneno = /(([2-9]\d{2}-\d{3}-\d{4})|(\([2-9]\d{2}\)-\d{3}-\d{4})|([2-9]\d{2}\.\d{3}\.\d{4}))([xX]\d{1,4})?/g;
            if (!phone.match(phoneno)) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.mobile.invalid +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        } else {
            error = 1;
            error_message = '<span id="error" class="form-error">'+ messages.mobile.required +'</span>';
            $(curParent).append(error_message).addClass('has-error');
            return false;
        }

        if (error == 0) { 
            hiddenphone.val(countryCode + ' ' + phone);
            console.log(hiddenphone.val());
            console.log('form submitted');
        }
    },
    /*sendEmail: function($obj) {
        var _this = this,
            messages = {
                firstname: {
                    required: 'Please enter your first name',
                },
                lastname: {
                    required: 'Please enter your last name',
                },
                email: {
                    required: 'Please enter your email address',
                    invalid: 'Please enter your valid email address'
                },
                birthday: {
                    required: 'Please select your birthday'
                },
                gender: {
                    required: 'Please select your gender'
                },
                mobile: {
                    required: 'Please enter your mobile number',
                    invalid: 'Please enter your valid mobile number'
                }
            };

        if (typeof $obj.data('membership') === 'undefined') {
            $('.success-message').addClass('hidden').html('');
        }
        var $form = $obj.parents('form'),
            error = 0,
            id = $obj.closest('.popup_notify_form').attr('id'),
            obj = '#'+ id +' form';
            
            first_name = $(obj + ' input[name="contact[first_name]"]').val();
            last_name = $(obj + ' input[name="contact[last_name]"]').val();
            email = $(obj + ' input[name="contact[email]"]').val();
            birth_day = $(obj + ' .birthdate-input .rise-select-dropdown.days .selected span:first-child').html();
            birth_month = $(obj + ' .birthdate-input .rise-select-dropdown.months .selected span:first-child').html();
            birth_year = $(obj + ' .birthdate-input .rise-select-dropdown.year .selected span:first-child').html();
            gender = $(obj + ' .gender-input .rise-select-dropdown .selected span:first-child').html();
            phone = $(obj + ' input[type="tel"][name="contact[phone]"]').val();
            hiddenphone = $(obj + ' input[type="hidden"][name="contact[phone]"]');
            countryCode = $('.country-list li.selected').data('code');
        
        if (typeof $obj.data('membership') !== 'undefined') {
            current = obj + ' input[name="contact[first_name]"]';
            curParent = $(current).parents('.name-input');
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (first_name.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.firstname.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            current = obj + ' input[name="contact[last_name]"]';
            curParent = $(current).parents('.name-input');
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (last_name.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.lastname.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        } else {
            current = obj + ' input[name="contact[email]"]';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            flag = _this.validateEmail(email);
            if (email.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.email.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
            if (email.length > 0 && flag == 1) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.email.invalid +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (typeof birth_day !== 'undefined' && typeof birth_month !== 'undefined' && typeof birth_year !== 'undefined') {
            current = obj + ' .birthdate-input .birthday-wrapper';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (birth_day == 'Day' || birth_month == 'Month' || birth_year == 'Year') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.birthday.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (typeof gender !== 'undefined') {
            current = obj + ' .gender-input .rise-select-dropdown .selected';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (gender == 'Please select one') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.gender.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        current = obj + ' .phone-input .group-control';
        curParent = $(current).parent();
        $(curParent).removeClass('has-error');
        $(curParent).children('#error').remove();
        if (!$(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            $(obj + ' input[type="tel"][name="contact[phone]"]').val('');
        }
        if ($(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            if (phone != '') {
                var phoneno = /(([2-9]\d{2}-\d{3}-\d{4})|(\([2-9]\d{2}\)-\d{3}-\d{4})|([2-9]\d{2}\.\d{3}\.\d{4}))([xX]\d{1,4})?/g;
                if (!phone.match(phoneno)) {
                    error = 1;
                    error_message = '<span id="error" class="form-error">'+ messages.mobile.invalid +'</span>';
                    $(curParent).append(error_message).addClass('has-error');
                    return false;
                }
            } else {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.mobile.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (error == 0) { 
            if ($(obj + ' input[type="tel"][name="contact[phone]"]').val() == '') {
                hiddenphone.val('');
            } else {
                hiddenphone.val(countryCode + ' ' + phone);
            }
            
            if ($obj.data('membership') !== 'undefined' && !$obj.hasClass('loading')) {
                $obj.addClass('loading');
                $obj.parents('.js-rise-popup-form').find('.success-message').addClass('hidden');
                $obj.addClass('loading animate').removeClass('default').find('[data-button-text]').text('Sending');
                setTimeout(function() {
                    $obj.removeClass('animate');
                }, 700);
            }

            if (typeof $obj.data('membership') !== 'undefined') {

                $.ajax({
                    type: 'POST',
                    //url: 'https://cloudpixelinfotech.com/rise-private-app/create-customer.php',
                    url: 'https://app.risestore.com/rise-private-app/membership-card.php',
                    data: $form.serialize(),
                    dataType: 'json',
                    success: function(response) {
                        if (response.success) {
                            setTimeout(function() {
                                $obj.addClass('done animate').find('[data-button-text]').text('Gift Card Sent');
                                setTimeout(function() {
                                    $obj.removeClass('loading done animate').addClass('default').find('[data-button-text]').text('Activate Gift Card');
                                    $obj.parents('.js-rise-popup-form').find('.success-message').removeClass('hidden');
                                    _this.clearFormData($form);
                                    $obj.closest('.js-rise-popup-form').find('[data-card-holder]').html('FULL NAME');
                                }, 2000);
                            }, 1600);
                        } else {
                            current = obj + ' .phone-input .group-control';
                            curParent = $(current).parent();
                            $(curParent).removeClass('has-error');
                            $(curParent).children('#error').remove();
                            error_message = '<span id="error" class="form-error">'+ response.message +'</span>';
                            setTimeout(function() {
                                $obj.removeClass('loading done animate').addClass('default').find('[data-button-text]').text('Activate Gift Card');
                                $(curParent).append(error_message).addClass('has-error');
                            }, 2000);
                        }
                    }
                });
                
            } else {
                $.ajax({
                    type: 'POST',
                    url: 'https://cloudpixelinfotech.com/rise-mailchimp/subscribe-contact.php',
                    data: $form.serialize(),
                    dataType: 'json',
                    success: function(response) {
                        if (response.data == 'subscribed' || response.data == 'updated') {
                            $obj.closest('.fancybox-content').find('.fancybox-close-small').trigger('click');
                            _this.clearFormData($form);
                            if (response.data == 'subscribed') {
                                $('body').append(_this.toastNoty('Success', response.message));
                            } else {
                                $('body').append(_this.toastNoty(response.message));
                            }
                            setTimeout(function() {
                                $('.rise-toaster.dynamic').addClass('active');
                                $('.rise-toaster.dynamic').find('svg.checkmark').addClass('active');
                            }, 500);
                            setTimeout(function() {
                                $('.rise-toaster.dynamic').removeClass('active');
                            }, 3000);
                        } else {
                            //_this.clearFormData($form);
                            $('.success-message').removeClass('hidden').html(response.message);
                        }
                    }
                });
            }
        }
    },*/
    subscribeToMailchimp: function($obj) {
        var _this = this,
            messages = {
                firstname: {
                    required: 'Please enter your first name',
                },
                lastname: {
                    required: 'Please enter your last name',
                },
                email: {
                    required: 'Please enter your email address',
                    invalid: 'Please enter your valid email address'
                },
                birthday: {
                    required: 'Please select your birthday'
                },
                gender: {
                    required: 'Please select your gender'
                },
                mobile: {
                    required: 'Please enter your mobile number',
                    invalid: 'Please enter your valid mobile number'
                }
            };
        
        //$('.success-message').addClass('hidden').html('');
        
        var $form = $obj.parents('form'),
            error = 0,
            id = $obj.closest('.popup_notify_form').attr('id'),
            obj = '#'+ id +' form';
            
            //first_name = $(obj + ' input[name="contact[first_name]"]').val();
            //last_name = $(obj + ' input[name="contact[last_name]"]').val();
            email = $(obj + ' input[name="contact[email]"]').val();
            birth_day = $(obj + ' .birthdate-input .rise-select-dropdown.days .selected span:first-child').html();
            birth_month = $(obj + ' .birthdate-input .rise-select-dropdown.months .selected span:first-child').html();
            birth_year = $(obj + ' .birthdate-input .rise-select-dropdown.year .selected span:first-child').html();
            gender = $(obj + ' .gender-input .rise-select-dropdown .selected span:first-child').html();
            phone = $(obj + ' input[type="tel"][name="contact[phone]"]').val();
            hiddenphone = $(obj + ' input[type="hidden"][name="contact[phone]"]');
            countryCode = $('.country-list li.selected').data('code');
        
        if ($obj.parents('.fancybox-container').length > 0) {
            var requiredFields = $obj.parents('.js-rise-popup-form').data('required-fields');
            var hasFormFields = $obj.parents('.js-rise-popup-form').data('form-fields');
        } else {
            var sectionId = $obj.parents('.shopify-section').attr('id');
            var requiredFields = JSON.parse($('#' + sectionId + '--Required').html());
            var hasFormFields = JSON.parse($('#' + sectionId + '--Show').html());
        }
        
        current = obj + ' input[name="contact[email]"]';
        curParent = $(current).parent();
        $(curParent).removeClass('has-error');
        $(curParent).children('#error').remove();
        flag = _this.validateEmail(email);
        if (email.length <= 0) {
            error = 1;
            error_message = '<span id="error" class="form-error">'+ messages.email.required +'</span>';
            $(current).focus();
            $(curParent).append(error_message).addClass('has-error');
            return false;
        }
        if (email.length > 0 && flag == 1) {
            error = 1;
            error_message = '<span id="error" class="form-error">'+ messages.email.invalid +'</span>';
            $(current).focus();
            $(curParent).append(error_message).addClass('has-error');
            return false;
        }
        
        if (hasFormFields.birthday == true && requiredFields.birthday) {
            current = obj + ' .birthdate-input .birthday-wrapper';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (birth_day == 'Day' || birth_month == 'Month' || birth_year == 'Year') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.birthday.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (hasFormFields.gender == true && requiredFields.gender) {
            current = obj + ' .gender-input .rise-select-dropdown .selected';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (gender == 'Please select one') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.gender.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        current = obj + ' .phone-input .group-control';
        curParent = $(current).parent();
        $(curParent).removeClass('has-error');
        $(curParent).children('#error').remove();
        if (!$(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            $(obj + ' input[type="tel"][name="contact[phone]"]').val('');
        }
        if ($(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            if (phone != '') {
                var phoneno = /(([2-9]\d{2}-\d{3}-\d{4})|(\([2-9]\d{2}\)-\d{3}-\d{4})|([2-9]\d{2}\.\d{3}\.\d{4}))([xX]\d{1,4})?/g;
                if (!phone.match(phoneno)) {
                    error = 1;
                    error_message = '<span id="error" class="form-error">'+ messages.mobile.invalid +'</span>';
                    $(curParent).append(error_message).addClass('has-error');
                    return false;
                }
            } else {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.mobile.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (error == 0) { 
            if ($(obj + ' input[type="tel"][name="contact[phone]"]').val() == '') {
                hiddenphone.val('');
            } else {
                hiddenphone.val(countryCode + ' ' + phone);
            }

            if (!$obj.hasClass('loading')) {
                $obj.addClass('loading animate');
            }

            $.ajax({
                type: 'POST',
                url: 'https://app.risestore.com/rise-membership/membership-card.php',
                data: $form.serialize(),
                dataType: 'JSON',
                success: function(response) {
                    $obj.removeClass('loading animate');
                    if (response.success) {
                        $obj.closest('.fancybox-content').find('.fancybox-close-small').trigger('click');
                        _this.clearFormData($form);
                        $('body').append(_this.toastNoty('Success', 'Thank you for subscribing!'));
                        setTimeout(function() {
                            $('.rise-toaster.dynamic').addClass('active');
                            $('.rise-toaster.dynamic').find('svg.checkmark').addClass('active');
                        }, 500);
                        setTimeout(function() {
                            $('.rise-toaster.dynamic').removeClass('active');
                        }, 3000);
                    } else {
                        if (response.data == 'phone') {
                            current = obj + ' .phone-input .group-control';
                            curParent = $(current).parent();
                            $(curParent).removeClass('has-error');
                            $(curParent).children('#error').remove();
                            error_message = '<span id="error" class="form-error">'+ response.message +'</span>';
                            $(curParent).append(error_message).addClass('has-error');
                        } else {
                            $('.form-response').removeClass('success-message hidden').addClass('error-message').html(response.message);
                        }
                    }
                }
            });
        }
    },
    subscribeForMembershipCard: function($obj) {
        var _this = this,
            messages = {
                firstname: {
                    required: 'Please enter your first name',
                },
                lastname: {
                    required: 'Please enter your last name',
                },
                email: {
                    required: 'Please enter your email address',
                    invalid: 'Please enter your valid email address'
                },
                birthday: {
                    required: 'Please select your birthday'
                },
                gender: {
                    required: 'Please select your gender'
                },
                mobile: {
                    required: 'Please enter your mobile number',
                    invalid: 'Please enter your valid mobile number'
                }
            };
        
        var $form = $obj.parents('form'),
            error = 0,
            id = $obj.closest('.popup_notify_form').attr('id'),
            obj = '#'+ id +' form';
            
            first_name = $(obj + ' input[name="contact[first_name]"]').val();
            last_name = $(obj + ' input[name="contact[last_name]"]').val();
            email = $(obj + ' input[name="contact[email]"]').val();
            birth_day = $(obj + ' .birthdate-input .rise-select-dropdown.days .selected span:first-child').html();
            birth_month = $(obj + ' .birthdate-input .rise-select-dropdown.months .selected span:first-child').html();
            birth_year = $(obj + ' .birthdate-input .rise-select-dropdown.year .selected span:first-child').html();
            gender = $(obj + ' .gender-input .rise-select-dropdown .selected span:first-child').html();
            phone = $(obj + ' input[type="tel"][name="contact[phone]"]').val();
            hiddenphone = $(obj + ' input[type="hidden"][name="contact[phone]"]');
            countryCode = $('.country-list li.selected').data('code');
        
        if ($obj.parents('.fancybox-container').length > 0) {
            var requiredFields = $obj.parents('.js-rise-popup-form').data('required-fields');
        } else {
            var sectionId = $obj.parents('.shopify-section').attr('id'),
                requiredFields = JSON.parse($('#' + sectionId + '--Required').html());
        }
        
        if (requiredFields.first_name) {
            current = obj + ' input[name="contact[first_name]"]';
            curParent = $(current).parents('.name-input');
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (first_name.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.firstname.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (requiredFields.last_name) {
            current = obj + ' input[name="contact[last_name]"]';
            curParent = $(current).parents('.name-input');
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (last_name.length <= 0) {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.lastname.required +'</span>';
                $(current).focus();
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (requiredFields.birthday) {
            current = obj + ' .birthdate-input .birthday-wrapper';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (birth_day == 'Day' || birth_month == 'Month' || birth_year == 'Year') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.birthday.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (requiredFields.gender) {
            current = obj + ' .gender-input .rise-select-dropdown .selected';
            curParent = $(current).parent();
            $(curParent).removeClass('has-error');
            $(curParent).children('#error').remove();
            if (gender == 'Please select one') {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.gender.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        current = obj + ' .phone-input .group-control';
        curParent = $(current).parent();
        $(curParent).removeClass('has-error');
        $(curParent).children('#error').remove();
        if (!$(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            $(obj + ' input[type="tel"][name="contact[phone]"]').val('');
        }
        if ($(obj + ' input[name="notified_by_sms"]').is(':checked')) {
            if (phone != '') {
                var phoneno = /(([2-9]\d{2}-\d{3}-\d{4})|(\([2-9]\d{2}\)-\d{3}-\d{4})|([2-9]\d{2}\.\d{3}\.\d{4}))([xX]\d{1,4})?/g;
                if (!phone.match(phoneno)) {
                    error = 1;
                    error_message = '<span id="error" class="form-error">'+ messages.mobile.invalid +'</span>';
                    $(curParent).append(error_message).addClass('has-error');
                    return false;
                }
            } else {
                error = 1;
                error_message = '<span id="error" class="form-error">'+ messages.mobile.required +'</span>';
                $(curParent).append(error_message).addClass('has-error');
                return false;
            }
        }

        if (error == 0) { 
            if ($(obj + ' input[type="tel"][name="contact[phone]"]').val() == '') {
                hiddenphone.val('');
            } else {
                hiddenphone.val(countryCode + ' ' + phone);
            }
            
            if (!$obj.hasClass('loading')) {
                $obj.addClass('loading');
                $obj.parents('.js-rise-popup-form').find('.success-message').addClass('hidden');
                $obj.addClass('loading animate').removeClass('default').find('[data-button-text]').text('Sending');
                setTimeout(function() {
                    $obj.removeClass('animate');
                }, 700);
            }

            $.ajax({
                type: 'POST',
                url: 'https://app.risestore.com/rise-membership/membership-card.php',
                data: $form.serialize(),
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        setTimeout(function() {
                            $obj.addClass('done animate').find('[data-button-text]').text('Gift Card Sent');
                            setTimeout(function() {
                                $obj.removeClass('loading done animate').addClass('default').find('[data-button-text]').text('Activate Gift Card');
                                $obj.parents('.js-rise-popup-form').find('.success-message').removeClass('hidden');
                                _this.clearFormData($form);
                                $obj.closest('.js-rise-popup-form').find('[data-card-holder]').html('FULL NAME');
                            }, 2000);
                        }, 1600);
                    } else {
                        if (response.data == 'phone') {
                            current = obj + ' .phone-input .group-control';
                            curParent = $(current).parent();
                            $(curParent).removeClass('has-error');
                            $(curParent).children('#error').remove();
                            error_message = '<span id="error" class="form-error">'+ response.message +'</span>';
                            setTimeout(function() {
                                $obj.removeClass('loading done animate').addClass('default').find('[data-button-text]').text('Activate Gift Card');
                                $(curParent).append(error_message).addClass('has-error');
                            }, 2000);
                        } else {
                            setTimeout(function() {
                                $obj.removeClass('loading done animate').addClass('default').find('[data-button-text]').text('Activate Gift Card');
                                $obj.parents('.popup_notify_form').find('.error-message').removeClass('hidden').html(response.message);
                            }, 2000);
                        }
                    }
                }
            });
        }
    },
    clearFormData: function($form) {
        if ($form.attr('id') != 'membership-form') {
            $form.find('input[name="contact[email]"]').val('');    
        }
        $form.find('input[name="contact[first_name]"], input[name="contact[last_name]"], input[name="contact[gender]"], input[name="contact[phone]"], input[name="contact[birth_day]"], input[name="contact[birth_month]"], input[name="contact[birth_year]"], input[name="list_search"]').val('');
        $form.find('.rise-select-dropdown.days .selected span:first-child').html('Day');
        $form.find('.rise-select-dropdown.months .selected span:first-child').html('Month');
        $form.find('.rise-select-dropdown.year .selected span:first-child').html('Year');
        $form.find('.rise-select-dropdown.gender .selected span:first-child').html('Please select one');
        $form.find('.rise-select-dropdown.country-with-code .selected span:first-child').html('+1');
        $form.find('.country-list li').removeClass('selected');
        $form.find('.country-list li[data-value="US"]').addClass('selected');
    },
    toastNoty: function(heading, message = null) {
        var animatedSVG = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" class="checkmark">' +
                                '<circle class="path circle" fill="none" stroke="#00EF62" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>' +
                                '<polyline class="path check" fill="none" stroke="#00EF62" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>' +
                            '</svg>';
        return '<div class="rise-toaster dynamic"> <div class="notification-wrapper"> <div class="notification-icon">' + animatedSVG + 
        '</div> <div class="notification-text"> <span class="notify-label">'+ heading +'</span> <p>'+ ((message != null) ? message : '') +'</p> <a href="javascript:void(0);" class="close">' +
    '<span class="icon icon--close"> <svg role="presentation" viewBox="0 0 20 20"> <path d="M20 2.01439L17.9857 0.000106812L10 7.98582L2.01429 0.000106812L0 2.01439L7.98571 10.0001L0 17.9858L2.01429 20.0001L10 12.0144L17.9857 20.0001L20 17.9858L12.0143 10.0001L20 2.01439Z" fill="white"></path></svg>' +
        '</span></a></div></div>' +
    '</div>';
    },
    validateEmail: function(inputtext) {
        var emailExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (inputtext.match(emailExp)) {
            return 0;
        } else {
            return 1;
        }
    },
}

/*============================================================================
  Rise VIP Notify Popup
==============================================================================*/
window.vipNotifyPopup = {
    init: function() { 
        $(document).on('click', '.vip-notify-popup', function(e) {
            e.preventDefault();
            $('.rise-select-dropdown .selected').removeClass('open');
            $.fancybox.open({
                src  : '#vip-notify-popup',
                type : 'inline',
                hideScrollbar: true,
                touch: true,
                mobile: {
                    modal: true,
                },
                beforeShow: function() {
                    window.bodyScrollLock.lockscroll();
                },
                afterClose: function() {
                    window.bodyScrollLock.releasescroll();
                }
            });
        });
    }
}

/*============================================================================
  Rise Custom Select
==============================================================================*/
window.riseCustomSelect = {
    setScrollYear: function(section) {
        if ($(section).length <= 0) return false;
        var section_position = $(section).offset().top;
        var animated = [];
        $(window).on('scroll', function() {
            var y_scroll_pos = window.pageYOffset;
            var scroll_pos_test = section_position;

            if (y_scroll_pos > scroll_pos_test && jQuery.inArray(section, animated) === -1) {
                $(section).find('.rise-select-dropdown.year').each(function( index ) {
                    var self = $(this);
                    self.find('.options').show();
                    var ele = $(this).get(0);
                    var target = ele.querySelector('.options li[data-value="1990"]');
                    target.parentNode.scrollTop = target.offsetTop - target.parentNode.offsetTop;
                    self.find('.options').hide();
                });
                animated.push(section);
            }
        });
    },
    init: function() {
        var _this = this;
        $(document).on('click', '.rise-select-dropdown:not(.country-with-code) .selected', function(e) { 
            e.preventDefault();
            $('.rise-select-dropdown .selected').not(this).removeClass('open');
            $('.rise-select-dropdown .selected').not(this).next('.options').hide();
            $('.rise-select-dropdown .selected').not(this).parent('.rise-select-dropdown').next('.options').hide();
            $(this).next('.options').toggle();
            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                if ($(this).parent('.rise-select-dropdown').hasClass('year')) {
                    //var ele = $(this).parent('.rise-select-dropdown').get(0);
                    //ele.querySelector('.options li[data-value="1990"]').scrollIntoView();
                    /*var $list = $(this).parent('.rise-select-dropdown').find('ul');
                    var $selected = $list.find('li[data-value="1990"]');
                    $list.animate({
                        scrollTop: ($selected.index() * $selected.outerHeight())
                    }, 'fast');*/
                }
                //$(this).parents('.rise-select-dropdown').find('input[name="list_search"]').focus();
            }
        });

        _this.setScrollYear('.shopify-section--rise-form');
        _this.setScrollYear('.shopify-section--rise-membership-form');
        
        $(document).on('click', '.rise-select-dropdown.country-with-code .selected', function() { 
            $('.rise-select-dropdown .selected').not(this).removeClass('open');
            $('.rise-select-dropdown .selected').not(this).next('.options').hide();
            $('.rise-select-dropdown .selected').not(this).parent('.rise-select-dropdown').next('.options').hide();
            $(this).parent('.rise-select-dropdown').next('.options').toggle();
            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                $(this).parents('.group-control').find('input[name="list_search"]').focus();
            } else {
                $(this).parents('.group-control').find('input[name="contact[phone]"]').focus();
            }
        });

        //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
        $(document).on('click', '.rise-select-dropdown:not(.country-with-code) .options ul li', function() {
            var text = $(this).html();
            $(this).parents('.rise-select-dropdown').find('.selected span:not(.icon)').html(text);
            $(this).parents('.rise-select-dropdown').find('input[type="hidden"]').val($(this).data('value'));
            $(this).parents('.rise-select-dropdown').find('.selected').removeClass('open');
            $('.rise-select-dropdown .options').hide();
            var warapper = $(this).closest('form');
            var parentEL = $(this).parents('.rise-select-dropdown');
            if (parentEL.hasClass('days')) {
                warapper.find('.rise-select-dropdown.months .selected').trigger('click');
            }
          	if (parentEL.hasClass('months')) {
                warapper.find('.rise-select-dropdown.year .selected').trigger('click');
            }
            if (parentEL.hasClass('year')) {
                warapper.find('.rise-select-dropdown.gender .selected').trigger('click');
            }
        }); 
        
        $(document).on('click', '.rise-select-dropdown.country-with-code ~ .options ul li', function() {
            var text = $(this).data('code');
            $(this).parents('.options').prev('.rise-select-dropdown').find('.selected span:not(.icon)').html(text);
            $(this).parents('.options').prev('.rise-select-dropdown').find('input[type="hidden"]').val(text);
            $('.rise-select-dropdown ~ .options').hide();
            $(this).parents('.options').prev('.rise-select-dropdown').find('.selected').removeClass('open');
            $(this).parents('.group-control').find('input[name="contact[phone]"]').focus();
        });

        //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
        $(document).bind('click', function(e) {
            var $clicked = $(e.target);
            if (! $clicked.parents().hasClass('rise-select-dropdown') && !$clicked.parents().hasClass('options')) {
                $('.rise-select-dropdown .options, .rise-select-dropdown ~ .options').hide();
                $('.rise-select-dropdown .selected').removeClass('open');
            }
        });
        
        /* Search Country In List */
        window.day = [];
        for (i = 1; i <= 31; i++) {
            window.day.push({'value': i, 'text': i});
        }
        window.month = [
            {'value': '01', 'text': 'JAN'},
            {'value': '02', 'text': 'FEB'},
            {'value': '03', 'text': 'MAR'},
            {'value': '04', 'text': 'APRIL'},
            {'value': '05', 'text': 'MAY'},
            {'value': '06', 'text': 'JUNE'},
            {'value': '07', 'text': 'JULY'},
            {'value': '08', 'text': 'AUG'},
            {'value': '09', 'text': 'SEPT'},
            {'value': '10', 'text': 'OCT'},
            {'value': '11', 'text': 'NOV'},
            {'value': '12', 'text': 'DEC'}
        ];
        window.year = [];
        for (i = 1920; i <= 2021; i++) {
            window.year.push({'value': i, 'text': i});
        }
        $(document).on('keyup', '.rise-select-dropdown:not([data-country-select]) input[name="list_search"]', function(e) {
            var searchString = $(this).val(),
                $listItems = '',
                $list = $(this).next('ul');
            if (e.keyCode != 38 && e.keyCode != 40) {
                var searchList = $(this).data('search');
                if (typeof searchList !== 'undefined') {
                    var list = window[searchList];
                    $(list).each(function(index, item) {
                        currentName = item.text.toString();
                        if (searchString == '' || currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
                            $listItems += '<li data-value="'+ item.value +'">'+ item.text +'</li>';
                        }
                    });
                    $list.html($listItems);
                }
            }

            $(e.target.nextElementSibling).find('li').removeClass('last-visible');
            $(e.target.nextElementSibling).find('li:visible:last').addClass('last-visible');
            if (isOverflown(e.target.nextElementSibling)) {
                e.target.nextElementSibling.classList.remove('hide-scrollbar');
            } else {
                e.target.nextElementSibling.classList.add('hide-scrollbar');
            }
        });

        function isOverflown(element) {
            return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
        }

        var selected = 0;
        $('input[name="list_search"]').keyup(function(e) {
            var $list = $(this).next('ul');
            var $listItem = $list.find('li').toArray();
            selected = $list.find('li.selected').index();

            if (e.keyCode === 38) { // up
                setSelectedListItem($listItem[selected - 1], $list, $listItem);
            }
            if (e.keyCode === 40) { // down
                setSelectedListItem($listItem[selected + 1], $list, $listItem);
            }
            
            
            /*if (e.which != 40 && e.which != 38) {
                $list.find('li').removeClass('selected');
            }
            if (e.which == 40) { 
                if ($list.find('li.selected').length != 0 ) { 
                    //var $nextSelected = $list.find('li.selected').next();
                    var $nextSelected = $list.find('li.selected').nextUntil('li.selected', 'li:not([style*="display: none"])');
                    $nextSelected = $nextSelected.first();
                    if ($nextSelected.length > 0 && $list.find('li.selected:not(:last-child)').length > 0) {
                        $list.find('li.selected').removeClass('selected');
                        $nextSelected.focus().addClass('selected');
                        $list.scrollTop($nextSelected.index() * $nextSelected.outerHeight() - 37);
                    }
                } else {
                    var $nextSelected = $list.find('li:not([style*="display: none"])');
                    $nextSelected = $nextSelected.first();
                    $nextSelected.focus().addClass('selected');
                }
                return;
            } else {
                if (e.which == 38) {
                    //var $nextSelected = $list.find('li.selected').prev();
                    var $nextSelected = $list.find('li.selected').prevUntil('li.selected', 'li:not([style*="display: none"])');
                    $nextSelected = $nextSelected.first();
                    if ($nextSelected.length > 0 && $list.find('li.selected:not(:first-child)').length > 0) {
                        $list.find('li.selected').removeClass('selected');
                        $nextSelected.focus().addClass('selected');
                        $list.scrollTop($nextSelected.index() * $nextSelected.outerHeight() - 37);
                    } else {
                        $list.scrollTop(0);
                    }
                }
                return;
            }*/
        });

        function setSelectedListItem(el, $list, $listItem) {
            var s = [].indexOf.call($listItem, el);
            if (s === -1) return;

            selected = s;

            var elHeight = $(el).outerHeight();
            var scrollTop = $list.scrollTop();
            var viewport = scrollTop + $list.height();
            var elOffset = elHeight * selected;
            
            if (elOffset < scrollTop || (elOffset + elHeight) > viewport) {
                $list.scrollTop(elOffset);
            }

            $list.find('li').removeClass('selected');
            el.classList.add('selected');
        }
    }
}

/*============================================================================
  Rise BottomSheet Add To Cart
==============================================================================*/
window.mobileAddToCartBottomSheet = {
    init: function() {
        $(document).ready(function() {
          if ($(window).width() < 798 && $('body').hasClass('product') == true) {
              var product = $('.product .product-block--form .product_form').data('product');
              if (product && product.variants != undefined && product.variants[0].title != 'Default Title') {
                  const productBlock = $('.product .product-block--form .product_form');
                  if (product.available) {
                      productBlock.find('.purchase-details .purchase-details__buttons').removeClass('product-is-unavailable');
                      productBlock.find('.swatch_options').find('input[type="radio"]').prop('checked', false);
                      productBlock.find('.purchase-details .add_to_cart').prop('disabled', false).removeClass('disabled').addClass('select-size');
                      var button_text = productBlock.find('.purchase-details .add_to_cart').data('button-text');
                      productBlock.find('.purchase-details .add_to_cart .text').html(button_text);
                      $('body').get(0).style.setProperty('--add-to-cart', 'block');
                  }
              }
              $(document).on('click', '.ModalStyles__SizeGuide, .size_chart', function(event) {
                  event.preventDefault();
                  $('body').addClass('size-guide-fixed');
              });
          }
        });
        if ($('body').hasClass('product') == true) {
            $(document).on('click', '.product-block--form .product_form .sold-out', function(event) {
                event.preventDefault();
                var form = $(this).closest('form');
                var variant = form.find('select[name="id"] option:selected').val();
                form.find('.swatch_options .swatch-element[data-id="'+ variant +'"]').trigger('click');
            });
            $(document).on('click', '#size-select_drawer .swatch_options .swatch-element', function(event) {
                var form = $(this).closest('form');
                var variant = form.find('select[name="id"] option:selected').val();
                $('.product-block--form .product_form .swatch_options .swatch-element[data-id="'+ variant +'"]').trigger('click');
            });
        }
        $(document).on('click', '.mobile-add-to-cart button:not(.add_to_cart):not(.soldout)', function() {
            var $obj = $(this);
            $obj.prop('disabled', true);
            $('body').addClass('bottomsheet-fixed');
        });
        $(document).on('click', '.bottomSheet-AddToCart button.close-bottomsheet, .bottomsheet-overlay', function() {
            $('.mobile-add-to-cart button').prop('disabled', false);
            $('body').removeClass('bottomsheet-fixed size-guide-fixed');
        });
        $(document).on('click', '.bottomSheet-SizeGuide .close-pane, .bottomSheet-SizeGuide button.close-bottomsheet', function() {
            $('body').removeClass('size-guide-fixed');
        });
        /*$(document).on('click', '.bottomSheet-SizeGuide button.close-bottomsheet', function() {
            $('body').addClass('size-guide-goes-down');
            setTimeout(function() {
                $('body').removeClass('size-guide-fixed size-guide-goes-down');
                $('.bottomSheet-SizeGuide').hide();
            }, 900);
        });*/
    }
}

var obj=document.body;  // obj=element for example body
// bind mousewheel event on the mouseWheel function
if(obj.addEventListener)
{
    obj.addEventListener('DOMMouseScroll',mouseWheel,false);
    obj.addEventListener("mousewheel",mouseWheel,false);
}
else obj.onmousewheel=mouseWheel;

function mouseWheel(e)
{
    // disabling
    e=e?e:window.event;
    if(e.ctrlKey)
    {
        if(e.preventDefault) e.preventDefault();
        else e.returnValue=false;
        return false;
    }
}

/*============================================================================
  Prevent Page scroll
==============================================================================*/
window.bodyScrollLock = {
    init: function() {
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
            document.documentElement.style.setProperty('--body-scroll-y', `-${window.scrollY}px`);
        });
    },
    lockscroll: function() {
        if (window.Shopify.media_queries.medium.matches) {
            const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
            const body = document.body;
            body.style.position = 'fixed';
            body.style.top = `-${scrollY}`;
        }
    },
    releasescroll: function() {
        if (window.Shopify.media_queries.medium.matches) {
            const body = document.body;
            const scrollY = body.style.top;
            body.style.position = '';
            body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    },
    iosScrollLock: function() {
        if (window.Shopify.media_queries.medium.matches) {
            const targetElement = document.querySelector('body');
            if ($('body').hasClass('blocked-scroll') == true) {
                bodyScrollLock1.disableBodyScroll(document.querySelector('.scrollbar-inner'));
                bodyScrollLock1.enableBodyScroll(document.querySelector('.scrollbar-inner'));
            } else {
                bodyScrollLock1.clearAllBodyScrollLocks();
            }
        }
    }
}

/*============================================================================
  Rise Store Locator
==============================================================================*/
window.storeLocator = {
    map: null,
    allLocations: [],
    storesData: [],
    currentPage: 1,
    record_per_page: 10,
    enableLoadMore: false,
    loadStores: function() {
        // Load Stores Data
        var result = [];
        $.ajax({
            //url: 'https://script.google.com/macros/s/AKfycbw7_QuvkM_MI_i_Y3VaVCJcah4Vc4MLJNe6FDoHxDVxsUyAzTHjYAcQtelAjiQXy69KmQ/exec?path=ProMap locations',
            url: 'https://script.google.com/macros/s/AKfycby1dwc5Cz_K6M008SfmiNy4Aglqrv9Sg5Kz3dds9qqKI3Qd8h_6ZDniZgrfhKNWn8JL/exec?path=ProMap%20locations',
            type: 'GET',
            async: false,
            dataType: 'json',
            success: function(data) {
                result = data;
            } 
        });
        return result;
    },
    infoWindow: null,
    mapPin: (document.querySelector('[data-map-marker]') != undefined) ? document.querySelector('[data-map-marker]').getAttribute('data-map-marker') : null,
    markers: [],
    searchContainer: (document.querySelector('.store-search-container') != undefined ? document.querySelector('.store-search-container') : null),
    searchPredictionHTML: function() {
        var Icon = document.querySelector('button[data-use-my-location]').cloneNode(true);
        var previousRiseUserLocationsData = JSON.parse(localStorage.getItem('previousRiseUserLocations'));
        var locationListHtml = '';
        if (previousRiseUserLocationsData != null) {
            locationListHtml = `<ul>`;
            previousRiseUserLocationsData.data.forEach(function(item) {
                locationListHtml += `<li>${item.display}</li>`;
            });
            locationListHtml += `</ul>`;
        }
        return `<div class="location-list">
                    <div class="use-my-location" data-use-my-location>
                        ${Icon.innerHTML}
                    </div>
                    ${locationListHtml}
                </div>`;
    },
    defaultLocation: {
        'lat': 40.20612271399455,
        'lon': -101.68548215531787,
        'display': '',
        'country': ''
    },
    searchBoxSelector: (document.getElementById('search-store') != undefined ? document.getElementById('search-store') : null),
    init: function() { 
        var _ = this;
        
        if (!$('body').hasClass('page-store-locator')) return false;
        
        this.initMap();

        var input = _.searchBoxSelector;
        input.addEventListener('focus', function(event) {
            event.target.value = '';
            var searchMain = _.searchContainer;
            if (searchMain.querySelector('.location-list') == null) {
                searchMain.insertAdjacentHTML('beforeend', _.searchPredictionHTML());
            }
            searchMain.querySelectorAll('.use-my-location[data-use-my-location]').forEach(item => {
                item.addEventListener('click', event => {
                    event.target.disabled = true;
                    $('.location-list').remove();
                    _.findNearestStores();
                    setTimeout(function() {
                        event.target.disabled = false;
                    }, 500);
                });
            });
            if (searchMain.querySelector('ul') != null) {
                var locations = searchMain.querySelector('ul');
                locations.querySelectorAll('li').forEach(function(item) {
                    item.addEventListener('click', function(event) {
                        _.setLocation(event);
                    });
                });
            }
        });
        input.addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                _.searchStores();
            } else {
                _.searchPredictions(event);
            }
        });
        
        var loadMore = document.getElementById('load-more-locations');
        loadMore.addEventListener('click', function(event) {
            var page = this.getAttribute('page');
            _.loadMoreStores(this, page);
        });
        
        $(document).on('click', '.map-tabs li a', function(event) {  
            event.preventDefault();
            $('.tab-pane').removeClass('tab-active');
            $('.map-tabs li a').removeClass('active');
            $(this).addClass('active');
            $('.tab-pane[data-id='+ $(this).data('rel') +']').addClass('tab-active');
        });

        document.querySelectorAll('button[data-use-my-location]').forEach(item => {
            item.addEventListener('click', event => {
                event.target.disabled = true;
                $('.location-list').remove();
                _.findNearestStores();
                setTimeout(function() {
                    event.target.disabled = false;
                }, 500);
            });
        });

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.store-search-container').length) {
                $('.location-list').remove();
                _.setSearchBoxValue();
            }
        });
    },
    initMap: function() {
        var _ = this;
        // Load Stores Data
        _.allLocations = this.loadStores();
        //this.storesData = this.allLocations;
        
        //if (navigator.geolocation) {
            //navigator.geolocation.getCurrentPosition(function(position) { 
                //_.defaultLocation.lat = position.coords.latitude;
                //_.defaultLocation.lon = position.coords.longitude;
                /*$.ajax({
                    url: 'https://ipapi.co/json/',
                    type: 'GET',
                    async: false,
                    dataType: 'json',
                    success: function(data) {
                        if (data.country == 'US' || data.country == 'CA') {
                            _.defaultLocation.lat = data.latitude;
                            _.defaultLocation.lon = data.longitude;
                            _.defaultLocation.display = data.city + ', ' + data.region_code;
                            _.defaultLocation.country = data.country;
                        }
                    }
                });*/
            //});
        //}
        
        // Create the map.
        _.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 4,
            center: {lat: _.defaultLocation.lat, lng: _.defaultLocation.lon},
            //styles: mapStyle,
        });
        _.infoWindow = new google.maps.InfoWindow();

        /*var stores = this.storesData;
        stores = stores.slice(0, this.record_per_page);
        this.displayStores(stores);
        this.showStoresMarkers(stores);
        this.setOnClickListener();
        var loadMore = document.getElementById('load-more-locations');
        this.updatePage(loadMore);*/

        /***** */
        var currentLatitude = _.defaultLocation.lat,
            currentLongitude = _.defaultLocation.lon,
            defaultValue = _.defaultLocation.display;
            setLocation = false,
            currentLocation = JSON.parse(localStorage.getItem('riseUserLocation'));
        if (currentLocation != null) {
            setLocation = true;
            currentLatitude = currentLocation.data.lat;
            currentLongitude = currentLocation.data.lon;
            defaultValue = currentLocation.data.display;
        }
        pos = { lat: currentLatitude, lng: currentLongitude };
        if (setLocation) {
            _.searchBoxSelector.value = defaultValue;
            _.searchStores(true, pos);
        } else {
            _.displayStores(_.allLocations);
            _.showStoresMarkers(_.allLocations);
            _.setOnClickListener();
        }
    },
    setSearchBoxValue: function() {
        var defaultValue = this.defaultLocation.display,
            currentLocation = JSON.parse(localStorage.getItem('riseUserLocation'));
        if (currentLocation != null) {
            defaultValue = currentLocation.data.display;
        }
        this.searchBoxSelector.value = defaultValue;
    },
    placeDetils: function(place_id) {
        var response = {
            'open_status': '',
            'store_image': ''
        };
        new Promise((resolve, reject) => {
            place_id = 'ChIJH0FYQ--iKogRTmNu8xIY704';
            
            
            //var placeData;
            var service = new google.maps.places.PlacesService(this.map); // note that it removes the content inside div with tag '#service-helper'
            service.getDetails({
                placeId: place_id
            }, function(place, status) {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    response = place;
                    return resolve(response);
                    //return;
                }
                //console.log(place);     
                //console.log(place.opening_hours);
                
            });
        });
        /*
        const getPlacesPostCodeById = async placeId =>
            new Promise((resolve, reject) => {
                if (!placeId) reject("placeId not provided")

                try {
                    new window.google.maps.places.PlacesService(
                        this.map
                    ).getDetails(
                        {
                            placeId,
                            fields: ["address_components"],
                        },
                        details => {
                            let postcode = null
                            details?.address_components?.forEach(entry => {
                                if (entry.types?.[0] === "postal_code") {
                                    postcode = entry.long_name
                                }
                            })
                            return resolve(postcode)
                        })
                } catch (e) {
                    reject(e)
                }
            });
            async function a() {
                const postcode = await getPlacesPostCodeById(place_id);
                console.log(postcode);
            }
            a();
            */
        /*$.ajax({
            url: `https://maps.googleapis.com/maps/api/place/details/json?place_id=${place_id}&key=AIzaSyAwzTir2YGnKxCCCm4rJiOlh_EjZMNt2Hs&language=en`,
            type: 'GET',
            //async: false,
            cache: false,
            dataType: 'jsonp',
            crossDomain: true,
            success: function(data) {
                console.log(data);
            }
        });*/
        return response;
    },
    /*getPlacesPostCodeById: function(placeId) {
        var _ = this;
        return new Promise((resolve, reject) => {
            if (!placeId) reject("placeId not provided");
            setTimeout(() => {
                new window.google.maps.places.PlacesService(
                    _.map
                ).getDetails(
                    {
                        placeId,
                        fields: ["address_components"],
                    },
                    details => {
                        let postcode = null
                        details.address_components.forEach(entry => {
                            if (entry.types[0] === "postal_code") {
                                postcode = entry.long_name
                            }
                        })
                        return resolve(postcode)
                    })
            }, 1000);
        });
    },*/
    displayStores: function(stores, reset = false) {
        var _ = this,
            storesHtml = '';
        if (reset) {
            $('.store-list[data-id="list"]').html('');
        }
        var lastIndex = $('.store-list[data-id="list"] li').length;
        
        stores.forEach(function (store, index) {
            var name = store.title;
            storesHtml += `<li class="store">
                            <div class="store-title">
                                <h3>${lastIndex + index + 1}. ${name}</h3>
                            </div>
                            <div class="store-address">
                                <p>${store.address}</p>
                                <p>${store.address2}</p>
                                <p>${store.city} ${store.state} ${store.zipcode}</p>
                            </div>
                            <div class="store-extra">
                                <a href="tel:${store.phone}">${store.phone}</a> ${(store.distance != undefined && store.distance!= '' ? '<span>' + store.distance + ' km</span>' : '')}
                            </div>
                        </li>`;
        });
        if (reset) {
            document.querySelector('.store-list').innerHTML = storesHtml;
        } else {
            document.querySelector('.store-list').innerHTML += storesHtml;
        }
        $('.store-list-container.scrollbar-inner').scrollbar();
    },
    showStoresMarkers: function(stores, pos = null) {
        var bounds = new google.maps.LatLngBounds();
        var _ = this;

        stores.forEach(function (store, index) {
            var latlng = new google.maps.LatLng(
                store.latitude,
                store.longitude);
            var name = store.title;
            var address = '<p>' + store.address + ' ' + store.address2 + '</p><p>' + store.city + ' ' + store.state + ' ' + store.zipcode + '</p>';
            var openStatusText = '';
            var phoneNumber = store.phone;
            var distance = store.distance;
            bounds.extend(latlng);
            _.createMarker(latlng, name, address, openStatusText, phoneNumber, distance, index);
        });
        
        if (pos != null) {
            //_.map.fitBounds(new google.maps.LatLng(pos.lat, pos.lng));
            if (_.map.getZoom() <= 4) {
                _.map.setZoom(10);
            } else {
                //_.map.setZoom(_.map.getZoom() - 1);
            }
            _.map.setCenter(pos);
            if (_.map.getZoom() > 15) {
                _.map.setZoom(15);
            }
        }
        //_.map.fitBounds(bounds);
    },
    createMarker: function(latlng, name, address, openStatusText, phoneNumber, distance, index) {
        var _ = this;
        var html = `<div class="store-info-window">
					<a href="https://www.google.com/maps/dir/?api=1&destination=${latlng}" target="_blank">
						<strong class="store-name">${name}</strong>
						<span class="address">${address}</span>
					</a>
					<div class="store-extra">
						<a href="tel:${phoneNumber}" class="phone-number">${phoneNumber}</a>
                        ${(openStatusText != undefined && openStatusText != '' ? '<span>' + openStatusText + '</span>' : '')}
                        ${(distance != undefined && distance != '' ? '<span>' + distance + ' km</span>' : '')}
					</div>
				</div>`;
        var riseIcon = {
            url: this.mapPin,
            scaledSize: new google.maps.Size(50, 50)
        };

        var marker = new google.maps.Marker({
            map: this.map,
            position: latlng,
            icon: riseIcon,
            animation: google.maps.Animation.DROP,
        });

        google.maps.event.addListener(marker, 'click', function () {
            //this.map.setCenter(marker.getPosition());
            //this.map.panTo(marker.getPosition());
            //this.map.panTo(latlng);
            
            _.infoWindow.setContent(html);
            _.infoWindow.open(_.map, marker);
    
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function () {
                marker.setAnimation(null);
            }, 700); // current maps duration in ms of one bounce (v3.13)
        });
        _.markers.push(marker);
    },
    setOnClickListener: function() {
        var _ = this;
        var storeElements = document.querySelectorAll('li.store');
        storeElements.forEach(function (elem, index) {
            elem.addEventListener('click', function (event) {
                storeElements.forEach(function(item) {
                    item.classList.remove('active');
                });
                event.target.closest('li').classList.add('active');
                google.maps.event.trigger(_.markers[index], 'click');
            })
        });
    },
    searchStores: function(currentLocation = false, pos = null) {
        var _ = this;
        _.storesData = [];
        var list = document.querySelector('.store-list'),
            q = _.searchBoxSelector.value;
            const emptyResults = document.querySelectorAll('.no-result');
            emptyResults.forEach(box => {
                box.remove();
            });
        if (q || currentLocation) {
            this.allLocations.forEach(function (store) {
                if (currentLocation) {
                    var distance = _.calculateDistance(pos.lat, pos.lng, store.latitude, store.longitude, 'K');
                    //if (distance <= 50) {
                        store.distance = Math.ceil(distance);
                        _.storesData.push(store);
                    //}
                } else {
                    var postal = store.zipcode.toString(),
                        state = store.state,
                        city = store.city;
                    if (postal.indexOf(q) > -1 || state.indexOf(q) > -1 || city.indexOf(q) > -1) {
                        _.storesData.push(store);
                    }
                }
            });

            geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: pos }, function(results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                    return null;
                }
                results = results[0];
                const addressComponent = results.address_components;
                addressComponent.forEach(function(item) {
                    if (item.types.includes('locality') || item.types.includes('administrative_area_level_2')) {
                        q = item.short_name;
                    }
                    if (item.types.includes('administrative_area_level_1')) {
                        q += ', ' + item.short_name;
                    }
                });
                _.searchBoxSelector.value = q;
            });
            /*if (_.storesData.length <= 0) {
                if (q == '') {
                    geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ location: pos }, function(results, status) {
                        if (status !== google.maps.GeocoderStatus.OK) {
                            return null;
                        }
                        results = results[0];
                        const addressComponent = results.address_components;
                        addressComponent.forEach(function(item) {
                            if (item.types.includes('locality') || item.types.includes('administrative_area_level_2')) {
                                q = item.short_name;
                            }
                            if (item.types.includes('administrative_area_level_1')) {
                                q += ', ' + item.short_name;
                            }
                        });

                        _.map.setZoom(11);
                        marker = new google.maps.Marker({
                            position: results.geometry.location,
                            map: _.map,
                        });
                        _.map.setCenter(marker.getPosition());

                        _.searchBoxSelector.value = q;
                        var emptyResult = `<div class="no-result"><p><strong>We were not able to find a store near "${q}".</strong>Please try a different location.</p></div>`;
                        list.insertAdjacentHTML('afterend', emptyResult);
                    });
                } else {
                    var emptyResult = `<div class="no-result"><p><strong>We were not able to find a store near "${q}".</strong>Please try a different location.</p></div>`;
                    list.insertAdjacentHTML('afterend', emptyResult);
                }
            }*/
        } else {
            this.storesData = this.allLocations;
        }
        this.clearLocations();
        _.storesData.sort((a, b) => a.distance > b.distance ? 1 : -1); // Ascending Sort
        var stores = _.storesData;
        if (_.enableLoadMore) {
            stores = stores.slice(0, this.record_per_page);
        }
        this.displayStores(stores, true);
        this.showStoresMarkers(stores, pos);
        this.setOnClickListener();
        if (_.enableLoadMore) {
            this.currentPage = 1;
            var loadMore = document.getElementById('load-more-locations');
            this.updatePage(loadMore);
        }
    },
    clearLocations: function() {
        this.infoWindow.close();
        for (var i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers.length = 0;
    },
    loadMoreStores: function($this, page) {
        var data = this.storesData;
        var start = (page * this.record_per_page),
            end = (start + this.record_per_page);
        data = data.slice(start, end);
        this.displayStores(data);
        this.showStoresMarkers(data);
        this.setOnClickListener();
        this.currentPage = parseInt(page) + 1;
        this.updatePage($this);
    },
    updatePage: function($this) {
        var totalPages = Math.ceil(this.storesData.length / this.record_per_page);
        if (this.currentPage < totalPages) {
            $this.setAttribute('page', this.currentPage);
            $this.parentNode.style.display = 'inherit';
        } else {
            $this.parentNode.style.display = 'none';
        }
    },
    findNearestStores: function() {
        var _ = this;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) { 
                var currentLatitude = position.coords.latitude;
                var currentLongitude = position.coords.longitude;
                pos = { lat: currentLatitude, lng: currentLongitude };
                _.searchBoxSelector.value = '';
                _.searchStores(true, pos);
            }, function(error) {
                var $modalHeading = $('.js-message-lightbox').find('[data-title]');
                    $messageText = $('.js-message-lightbox').find('[data-message]');
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        $modalHeading.html('Location sharing disabled');
                        $messageText.html('To share your location, please update your browser settings.');
                    break;
                    case error.POSITION_UNAVAILABLE:
                        $modalHeading.html('Location unavailable');
                        $messageText.html('Location information is unavailable.');
                    break;
                    case error.TIMEOUT:
                        $modalHeading.html('Location timed out');
                        $messageText.html('The request to get user location timed out.');
                    break;
                    case error.UNKNOWN_ERROR:
                        $modalHeading.html('Error');
                        $messageText.html('An unknown error occurred.');
                    break;
                }

                if (!$('.fancybox-active').length) {
                    $.fancybox.open($('.js-message-lightbox'), {
                        baseClass: `message-popup__lightbox`,
                        hash: false,
                        infobar : false,
                        toolbar: false,
                        loop: false,
                        smallBtn : true,
                        video: {
                            autoStart: false
                        },
                        touch: false,
                        mobile: {
                            preventCaptionOverlap: false,
                            toolbar: true,
                            buttons: [
                                "close"
                            ]
                        }
                    });
                }

            });
        }
    },
    calculateDistance: function(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        } else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            return dist;
            // Miles (By Default) = M
            // Kilometers = K
            // Nautical Miles = N
        }
    },
    searchPredictions: function($this) {
        var _ = this,
            q = $this.target.value;
        const displaySuggestions = (predictions, status) => {
            var searchMain = _.searchContainer;
            if (searchMain.querySelector('.dd-no-result') != null) {
                searchMain.querySelector('.dd-no-result').remove();
            }

            if (status != google.maps.places.PlacesServiceStatus.OK) {
                if (status == 'ZERO_RESULTS') {
                    const noResult = `<div class="dd-no-result">
                                        <p>We are not able to find a store near "${q}". Please try a different location.</p>  
                                    </div>`;
                    searchMain.querySelector('.location-list').insertAdjacentHTML('afterbegin', noResult);
                }
                return;
            }
            
            if (searchMain.querySelector('ul') == null) {
                searchMain.querySelector('.location-list').insertAdjacentHTML('beforeend', '<ul></ul>');
            }
            var locations = searchMain.querySelector('ul'),
                li = '';

            // use forEch method to populate the
            // returned preditions in the Array
            predictions.forEach(prediction => {
                li += `<li>${prediction.description}</li>`;
            });
            locations.innerHTML = li;
            locations.querySelectorAll('li').forEach(function(item) {
                item.addEventListener('click', function(event) {
                    _.setLocation(event);
                });
            });
        };

        var options = {
            input: q,
            types: ['(cities)'],
            componentRestrictions: {country: ['us', 'ca']}
        };

        // change the string inside the input property as you wish and get the predicted list stored in a variable
        const service = new google.maps.places.AutocompleteService();
        service.getPredictions(options, displaySuggestions);
    },
    setLocation: function(event) {
        var _ = this;
        geocoder = new google.maps.Geocoder();
        const address = event.target.innerHTML;
        geocoder.geocode({ address: address }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                return null;
            }
            results = results[0];
            const pos = { lat: results.geometry.location.lat(), lng: results.geometry.location.lng() };
            const addressComponent = results.address_components;
            var display,
                country;
            addressComponent.forEach(function(item) {
                if (item.types.includes('locality') || item.types.includes('administrative_area_level_2')) {
                    display = item.short_name;
                }
                if (item.types.includes('administrative_area_level_1')) {
                    display += ', ' + item.short_name;
                }
                if (item.types.includes('country')) {
                    country = item.short_name;
                }
            });
            
            var userLocationData = {
                "data": {
                    "src": "PREDICTION",
                    "lat": pos.lat,
                    "lon": pos.lng,
                    "display": display,
                    "country": country
                }
            };
            event.target.closest('.location-list').remove();
            _.searchBoxSelector.value = display;
            _.searchStores(true, pos);
            if (_.storesData.length > 0) {
                localStorage.setItem('riseUserLocation', JSON.stringify(userLocationData));
                var previousRiseUserLocationsData = JSON.parse(localStorage.getItem('previousRiseUserLocations'));
                if (previousRiseUserLocationsData == null) {
                    previousRiseUserLocationsData = {
                        "data": []
                    };
                }
                if (undefined == previousRiseUserLocationsData.data.find(key => key.display === display)) {
                    previousRiseUserLocationsData.data.push(userLocationData.data);
                }
                localStorage.setItem('previousRiseUserLocations', JSON.stringify(previousRiseUserLocationsData));
            }
        });
    }
}

/*
$(document).on('focus blur', '#password-notify-popup select, #password-notify-popup textarea, #password-notify-popup input', function(e){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
        $('#password-notify-popup.popup_notify_form').css({
            "position": "absolute",
            "top": "0",
            "left": "50%",
            "transform": "translateX(-50%)",
            "max-width": "calc(100% - 20px)"
        });
    }
});

$(document).on('focusout', '#password-notify-popup select, #password-notify-popup textarea, #password-notify-popup input', function(e){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
        $('#password-notify-popup.popup_notify_form').css({
            "position": "",
            "left": "",
            "transform": "",
            "top": "",
            "max-width": ""
        });
    }
});*/
